import { Addy_2over3drawer_dresser } from '../components/models/addy_2over3drawer_dresser';
import { Addy_3drawer_bedside_dresser } from '../components/models/addy_3drawer_bedside_dresser';
import { Addy_4over4drawer_dresser } from '../components/models/addy_4over4drawer_dresser';
import { Addy_bedside_cabinet } from '../components/models/addy_bedside_cabinet';
import { Addy_blanket_chest } from '../components/models/addy_blanket_chest';
import { Addy_double_dresser_54 } from '../components/models/addy_double_dresser_54';
import { Addy_double_dresser_65 } from '../components/models/addy_double_dresser_65';
import { Addy_hideaway_dresser } from '../components/models/addy_hideaway_dresser';
import { Addy_lingerie_dresser } from '../components/models/addy_lingerie_dresser';
import { Addy_side_table } from '../components/models/addy_side_table';
import { Addy_side_table_with_shelf } from '../components/models/addy_side_table_with_shelf';
import { Amelia_side_table } from '../components/models/amelia_side_table';
import { Annie_bed } from '../components/models/annie_bed';
import { Astrid_chair } from '../components/models/astrid_chair';
import { Barrett_bamboo_arm_chair } from '../components/models/barrett_bamboo_arm_chair';
import { Barrett_bamboo_chair } from '../components/models/barrett_bamboo_chair';
import { Bay_bedside_cabnet } from '../components/models/bay_bedside_cabnet';
import { Bay_double_window_seat } from '../components/models/bay_double_window_seat';
import { Bed_bin } from '../components/models/bed_bin';
import { Big_cay_desk } from '../components/models/big_cay_desk';
import { Big_cay_desk_with_library_hutch } from '../components/models/big_cay_desk_with_library_hutch';
import { Billie_chair } from '../components/models/billie_chair';
import { Blair_sofa } from '../components/models/blair_sofa';
import { Blanche_oval_coffee_table_with_scallops } from '../components/models/blanche_oval_coffee_table_with_scallops';
import { Bloom_tea_table } from '../components/models/bloom_tea_table';
import { Boat_hull_coffee_table } from '../components/models/boat_hull_coffee_table';
import { Boat_hull_hall_table } from '../components/models/boat_hull_hall_table';
import { Boothbay_dining_chair_natural } from '../components/models/boothbay_dining_chair_natural';
import { Boothbay_dining_chair_painted } from '../components/models/boothbay_dining_chair_painted';
import { Boothbay_dining_cushion_only } from '../components/models/boothbay_dining_cushion_only';
import { Breakers_card_table } from '../components/models/breakers_card_table';
import { Breakers_dining_table } from '../components/models/breakers_dining_table';
import { Breakers_extension_dining_table } from '../components/models/breakers_extension_dining_table';
import { Cable_lock_dining_table } from '../components/models/cable_lock_dining_table';
import { Calvin_bed } from '../components/models/calvin_bed';
import { Castanet_stool } from '../components/models/castanet_stool';
import { Charlie_media_console } from '../components/models/charlie_media_console';
import { Charlie_round_side_table } from '../components/models/charlie_round_side_table';
import { Charlotte_2over3_drawer_dresser } from '../components/models/charlotte_2over3_drawer_dresser';
import { Charlotte_3_drawer_dresser } from '../components/models/charlotte_3_drawer_dresser';
import { Charlotte_bed } from '../components/models/charlotte_bed';
import { Charlotte_bedside_dresser } from '../components/models/charlotte_bedside_dresser';
import { Charlotte_double_dresser } from '../components/models/charlotte_double_dresser';
import { Chesapeake_bench } from '../components/models/chesapeake_bench';
import { Chesapeake_coffee_table } from '../components/models/chesapeake_coffee_table';
import { Chesapeake_end_table } from '../components/models/chesapeake_end_table';
import { Classic_cottage_sofa_table } from '../components/models/classic_cottage_sofa_table';
import { Classic_maine_cottage_end_table } from '../components/models/classic_maine_cottage_end_table';
import { Cokie_barstool_painted } from '../components/models/cokie_barstool_painted';
import { Cokie_counter_stool_painted } from '../components/models/cokie_counter_stool_painted';
import { Cokie_desk_chair_painted } from '../components/models/cokie_desk_chair_painted';
import { Cokie_dining_chair_painted } from '../components/models/cokie_dining_chair_painted';
import { Cube_ottoman } from '../components/models/cube_ottoman';
import { Daphne_chair } from '../components/models/daphne_chair';
import { Daphne_long_sofa_x } from '../components/models/daphne_long_sofa_x';
import { Daphne_ottoman } from '../components/models/daphne_ottoman';
import { Daphne_sofa_x } from '../components/models/daphne_sofa_x';
import { Della_cocktail_table } from '../components/models/della_cocktail_table';
import { Della_dining_table } from '../components/models/della_dining_table';
import { Edna_dining_chair_painted } from '../components/models/edna_dining_chair_painted';
import { Eleanor_chair } from '../components/models/eleanor_chair';
import { Eleanor_ottoman } from '../components/models/eleanor_ottoman';
import { Eliza_cannonball_bed_with_storage } from '../components/models/eliza_cannonball_bed_with_storage';
import { Elle_long_sofa } from '../components/models/elle_long_sofa';
import { Eloise_ottoman } from '../components/models/eloise_ottoman';
import { Evy_chair } from '../components/models/evy_chair';
import { Evy_ottoman } from '../components/models/evy_ottoman';
import { Extra_large_stowaway_shelf } from '../components/models/extra_large_stowaway_shelf';
import { Fiddlehead_cocktail_table } from '../components/models/fiddlehead_cocktail_table';
import { Fiddlehead_end_table } from '../components/models/fiddlehead_end_table';
import { Flora_chair } from '../components/models/flora_chair';
import { Flora_ottoman } from '../components/models/flora_ottoman';
import { Flora_wedge_sofa_x } from '../components/models/flora_wedge_sofa_x';
import { Francine_sofa_x } from '../components/models/francine_sofa_x';
import { Frannie_coffee_table } from '../components/models/frannie_coffee_table';
import { Frannie_farmhouse_dining_bench } from '../components/models/frannie_farmhouse_dining_bench';
import { Frannie_farmhouse_dining_table } from '../components/models/frannie_farmhouse_dining_table';
import { Freya_bench } from '../components/models/freya_bench';
import { Great_island_bookshelf } from '../components/models/great_island_bookshelf';
import { Gretchen_chair } from '../components/models/gretchen_chair';
import { Hailey_swivel_chair } from '../components/models/hailey_swivel_chair';
import { Hannah_blanket_chest } from '../components/models/hannah_blanket_chest';
import { Hannah_chair } from '../components/models/hannah_chair';
import { Harlow_wedge_sofa } from '../components/models/harlow_wedge_sofa';
import { Hazel_chair } from '../components/models/hazel_chair';
import { Henry_chair } from '../components/models/henry_chair';
import { High_tide_bed } from '../components/models/high_tide_bed';
import { Hooks_3 } from '../components/models/hooks_3';
import { Hooks_5 } from '../components/models/hooks_5';
import { Hutton_sofa } from '../components/models/hutton_sofa';
import { Ida_swivel_counter_stool } from '../components/models/ida_swivel_counter_stool';
import { Inga_trestle_dining_table } from '../components/models/inga_trestle_dining_table';
import { Island_bed } from '../components/models/island_bed';
import { Island_bedside_cabinet } from '../components/models/island_bedside_cabinet';
import { Island_media_center } from '../components/models/island_media_center';
import { Island_settee } from '../components/models/island_settee';
import { Jack_dining_chair } from '../components/models/jack_dining_chair';
import { James_ottoman } from '../components/models/james_ottoman';
import { Jill_dining_chair } from '../components/models/jill_dining_chair';
import { Joey_sofa } from '../components/models/joey_sofa';
import { Judy_bar_stool_natural } from '../components/models/judy_bar_stool_natural';
import { Judy_bar_stool_painted } from '../components/models/judy_bar_stool_painted';
import { Judy_counter_stool_natural } from '../components/models/judy_counter_stool_natural';
import { Judy_counter_stool_painted } from '../components/models/judy_counter_stool_painted';
import { Judy_dining_chair_natural } from '../components/models/judy_dining_chair_natural';
import { Judy_dining_chair_painted } from '../components/models/judy_dining_chair_painted';
import { Large_charlie_buffet } from '../components/models/large_charlie_buffet';
import { Large_margate_buffet } from '../components/models/large_margate_buffet';
import { Large_stowaway_shelf } from '../components/models/large_stowaway_shelf';
import { Largest_stowaway_shelf } from '../components/models/largest_stowaway_shelf';
import { Lattice_3drawer_dresser } from '../components/models/lattice_3drawer_dresser';
import { Lattice_bed } from '../components/models/lattice_bed';
import { Lattice_day_bed } from '../components/models/lattice_day_bed';
import { Lattice_double_dresser } from '../components/models/lattice_double_dresser';
import { Lattice_tall_dresser_2over3 } from '../components/models/lattice_tall_dresser_2over3';
import { Lilah_swivel_chair } from '../components/models/lilah_swivel_chair';
import { Lillian_bench } from '../components/models/lillian_bench';
import { Little_cay_desk } from '../components/models/little_cay_desk';
import { Lottie_dining_bench } from '../components/models/lottie_dining_bench';
import { Lottie_leaf_coffee_table } from '../components/models/lottie_leaf_coffee_table';
import { Lottie_leaf_console_table } from '../components/models/lottie_leaf_console_table';
import { Lottie_leaf_dining_table } from '../components/models/lottie_leaf_dining_table';
import { Lottie_leaf_stool } from '../components/models/lottie_leaf_stool';
import { Lottie_leaf_writing_desk } from '../components/models/lottie_leaf_writing_desk';
import { Lottie_side_table } from '../components/models/lottie_side_table';
import { Low_tide_day_bed } from '../components/models/low_tide_day_bed';
import { Low_tide_desk } from '../components/models/low_tide_desk';
import { Low_tide_hall_table } from '../components/models/low_tide_hall_table';
import { Mabel_bed } from '../components/models/mabel_bed';
import { Margaret_bench } from '../components/models/margaret_bench';
import { Margate_bookshelf_with_doors } from '../components/models/margate_bookshelf_with_doors';
import { Margate_dining_table } from '../components/models/margate_dining_table';
import { Margate_extension_dining_table } from '../components/models/margate_extension_dining_table';
import { Margate_media_console } from '../components/models/margate_media_console';
import { Margot_chair } from '../components/models/margot_chair';
import { Max_chair } from '../components/models/max_chair';
import { Medium_stowaway_shelf } from '../components/models/medium_stowaway_shelf';
import { Meriweather_bed } from '../components/models/meriweather_bed';
import { Mia_bench } from '../components/models/mia_bench';
import { Milly_storage_ottoman } from '../components/models/milly_storage_ottoman';
import { Milly_twin_sleeper_chair } from '../components/models/milly_twin_sleeper_chair';
import { Minnie_counter_stool } from '../components/models/minnie_counter_stool';
import { Molly_bench } from '../components/models/molly_bench';
import { Monty_sofa } from '../components/models/monty_sofa';
import { Morgan_ottoman } from '../components/models/morgan_ottoman';
import { Nellie_2drawer_bedside_table } from '../components/models/nellie_2drawer_bedside_table';
import { Nellie_2over2dresser } from '../components/models/nellie_2over2dresser';
import { Nellie_3drawer_dresser } from '../components/models/nellie_3drawer_dresser';
import { Nellie_double_dresser } from '../components/models/nellie_double_dresser';
import { Nellie_end_table } from '../components/models/nellie_end_table';
import { Olivia_chair } from '../components/models/olivia_chair';
import { Oscar_chair } from '../components/models/oscar_chair';
import { Paige_bench } from '../components/models/paige_bench';
import { Piper_chair } from '../components/models/piper_chair';
import { Quinn_chair } from '../components/models/quinn_chair';
import { Retreat_monterey_barrel_back_swivel_chair } from '../components/models/retreat_monterey_barrel_back_swivel_chair';
import { Retreat_monterey_chair } from '../components/models/retreat_monterey_chair';
import { Retreat_monterey_sofa } from '../components/models/retreat_monterey_sofa';
import { Retreat_nantucket_chair } from '../components/models/retreat_nantucket_chair';
import { Retreat_nantucket_chair_and_a_half_sleeper } from '../components/models/retreat_nantucket_chair_and_a_half_sleeper';
import { Retreat_nantucket_sofa } from '../components/models/retreat_nantucket_sofa';
import { Retreat_palm_beach_chair } from '../components/models/retreat_palm_beach_chair';
import { Ruben_hassock } from '../components/models/ruben_hassock';
import { Ruby_sound_cabinet } from '../components/models/ruby_sound_cabinet';
import { Shelby_bench } from '../components/models/shelby_bench';
import { Shelby_chair } from '../components/models/shelby_chair';
import { Shelby_ottoman } from '../components/models/shelby_ottoman';
import { Shelby_sofa } from '../components/models/shelby_sofa';
import { Shutter_bed } from '../components/models/shutter_bed';
import { Signature_cord_welt_pillow } from '../components/models/signature_cord_welt_pillow';
import { Signature_kidney_pillow } from '../components/models/signature_kidney_pillow';
import { Skinniest_island_bookshelf } from '../components/models/skinniest_island_bookshelf';
import { Small_island_bookshelf } from '../components/models/small_island_bookshelf';
import { Small_margate_buffet } from '../components/models/small_margate_buffet';
import { Small_stowaway_shelf } from '../components/models/small_stowaway_shelf';
import { Smallest_island_bookshelf } from '../components/models/smallest_island_bookshelf';
import { Stevie_sofa_x } from '../components/models/stevie_sofa_x';
import { Suri_ottoman } from '../components/models/suri_ottoman';
import { Tall_stowaway_shelf } from '../components/models/tall_stowaway_shelf';
import { Tide_pool_hall_table } from '../components/models/tide_pool_hall_table';
import { Tide_pool_side_table } from '../components/models/tide_pool_side_table';
import { Tilly_chair } from '../components/models/tilly_chair';
import { Tilly_ottoman } from '../components/models/tilly_ottoman';
import { Topper_coffee_table } from '../components/models/topper_coffee_table';
import { Trundle_bed } from '../components/models/trundle_bed';
import { Tulla_tuffet_ottoman } from '../components/models/tulla_tuffet_ottoman';
import { Wendy_side_table } from '../components/models/wendy_side_table';
import { Wilton_skirted_ottoman } from '../components/models/wilton_skirted_ottoman';
import { Wilton_skirtless_sofa } from '../components/models/wilton_skirtless_sofa';
import { Windsor_arm_chair_painted } from '../components/models/Windsor_arm_chair_painted';
import { Windsor_dining_chair_painted } from '../components/models/windsor_dining_chair_painted';
import { Wilton_skirted_sofa } from '../components/models/wilton_skirted_sofa';
import { Flora_sofa_and_loveseat } from '../components/models/flora_sofa_and_loveseat';
export const products = [
  { name: 'Addy_2over3drawer_dresser', component: Addy_2over3drawer_dresser },
  {
    name: 'Addy_3drawer_bedside_dresser',
    component: Addy_3drawer_bedside_dresser,
  },
  { name: 'Addy_4over4drawer_dresser', component: Addy_4over4drawer_dresser },
  { name: 'Addy_bedside_cabinet', component: Addy_bedside_cabinet },
  { name: 'Addy_bedside_cabinet', component: Addy_bedside_cabinet },
  { name: 'Addy_blanket_chest', component: Addy_blanket_chest },
  { name: 'Addy_double_dresser_54', component: Addy_double_dresser_54 },
  { name: 'Addy_double_dresser_65', component: Addy_double_dresser_65 },
  { name: 'Addy_hideaway_dresser', component: Addy_hideaway_dresser },
  { name: 'Addy_lingerie_dresser', component: Addy_lingerie_dresser },
  { name: 'Addy_side_table', component: Addy_side_table },
  { name: 'Addy_side_table_with_shelf', component: Addy_side_table_with_shelf },
  { name: 'Amelia_side_table', component: Amelia_side_table },
  { name: 'Annie_bed', component: Annie_bed },
  { name: 'Annie_bed', component: Annie_bed },
  { name: 'Annie_bed', component: Annie_bed },
  { name: 'Astrid_chair', component: Astrid_chair },
  { name: 'Barrett_bamboo_arm_chair', component: Barrett_bamboo_arm_chair },
  { name: 'Barrett_bamboo_chair', component: Barrett_bamboo_chair },
  { name: 'Bay_bedside_cabnet', component: Bay_bedside_cabnet },
  { name: 'Bay_bedside_cabnet', component: Bay_bedside_cabnet },
  { name: 'Bay_double_window_seat', component: Bay_double_window_seat },
  { name: 'Bed_bin', component: Bed_bin },
  { name: 'Big_cay_desk', component: Big_cay_desk },
  {
    name: 'Big_cay_desk_with_library_hutch',
    component: Big_cay_desk_with_library_hutch,
  },
  { name: 'Billie_chair', component: Billie_chair },
  { name: 'Blair_sofa', component: Blair_sofa },
  {
    name: 'Blanche_oval_coffee_table_with_scallops',
    component: Blanche_oval_coffee_table_with_scallops,
  },
  { name: 'Bloom_tea_table', component: Bloom_tea_table },
  { name: 'Boat_hull_coffee_table', component: Boat_hull_coffee_table },
  { name: 'Boat_hull_hall_table', component: Boat_hull_hall_table },
  {
    name: 'Boothbay_dining_chair_natural',
    component: Boothbay_dining_chair_natural,
  },
  {
    name: 'Boothbay_dining_chair_painted',
    component: Boothbay_dining_chair_painted,
  },
  {
    name: 'Boothbay_dining_cushion_only',
    component: Boothbay_dining_cushion_only,
  },
  { name: 'Breakers_card_table', component: Breakers_card_table },
  { name: 'Breakers_dining_table', component: Breakers_dining_table },
  { name: 'Breakers_dining_table', component: Breakers_dining_table },
  { name: 'Breakers_dining_table', component: Breakers_dining_table },
  {
    name: 'Breakers_extension_dining_table',
    component: Breakers_extension_dining_table,
  },
  {
    name: 'Breakers_extension_dining_table',
    component: Breakers_extension_dining_table,
  },
  { name: 'Cable_lock_dining_table', component: Cable_lock_dining_table },
  { name: 'Cable_lock_dining_table', component: Cable_lock_dining_table },
  { name: 'Cable_lock_dining_table', component: Cable_lock_dining_table },
  { name: 'Calvin_bed', component: Calvin_bed },
  { name: 'Calvin_bed', component: Calvin_bed },
  { name: 'Calvin_bed', component: Calvin_bed },
  { name: 'Calvin_bed', component: Calvin_bed },
  { name: 'Castanet_stool', component: Castanet_stool },
  { name: 'Charlie_media_console', component: Charlie_media_console },
  { name: 'Charlie_round_side_table', component: Charlie_round_side_table },
  {
    name: 'Charlotte_2over3_drawer_dresser',
    component: Charlotte_2over3_drawer_dresser,
  },
  {
    name: 'Charlotte_2over3_drawer_dresser',
    component: Charlotte_2over3_drawer_dresser,
  },
  { name: 'Charlotte_3_drawer_dresser', component: Charlotte_3_drawer_dresser },
  { name: 'Charlotte_3_drawer_dresser', component: Charlotte_3_drawer_dresser },
  { name: 'Charlotte_bed', component: Charlotte_bed },
  { name: 'Charlotte_bed', component: Charlotte_bed },
  { name: 'Charlotte_bed', component: Charlotte_bed },
  { name: 'Charlotte_bed', component: Charlotte_bed },
  { name: 'Charlotte_bedside_dresser', component: Charlotte_bedside_dresser },
  { name: 'Charlotte_bedside_dresser', component: Charlotte_bedside_dresser },
  { name: 'Charlotte_double_dresser', component: Charlotte_double_dresser },
  { name: 'Charlotte_double_dresser', component: Charlotte_double_dresser },
  { name: 'Chesapeake_bench', component: Chesapeake_bench },
  { name: 'Chesapeake_coffee_table', component: Chesapeake_coffee_table },
  { name: 'Chesapeake_end_table', component: Chesapeake_end_table },
  { name: 'Classic_cottage_sofa_table', component: Classic_cottage_sofa_table },
  {
    name: 'Classic_maine_cottage_end_table',
    component: Classic_maine_cottage_end_table,
  },
  { name: 'Cokie_barstool_painted', component: Cokie_barstool_painted },
  {
    name: 'Cokie_counter_stool_painted',
    component: Cokie_counter_stool_painted,
  },
  { name: 'Cokie_desk_chair_painted', component: Cokie_desk_chair_painted },
  { name: 'Cokie_dining_chair_painted', component: Cokie_dining_chair_painted },
  { name: 'Cube_ottoman', component: Cube_ottoman },
  { name: 'Daphne_chair', component: Daphne_chair },
  { name: 'Daphne_long_sofa_x', component: Daphne_long_sofa_x },
  { name: 'Daphne_ottoman', component: Daphne_ottoman },
  { name: 'Daphne_sofa_x', component: Daphne_sofa_x },
  { name: 'Della_cocktail_table', component: Della_cocktail_table },
  { name: 'Della_dining_table', component: Della_dining_table },
  { name: 'Della_dining_table', component: Della_dining_table },
  { name: 'Della_dining_table', component: Della_dining_table },
  { name: 'Edna_dining_chair_painted', component: Edna_dining_chair_painted },
  { name: 'Eleanor_chair', component: Eleanor_chair },
  { name: 'Eleanor_ottoman', component: Eleanor_ottoman },
  {
    name: 'Eliza_cannonball_bed_with_storage',
    component: Eliza_cannonball_bed_with_storage,
  },
  {
    name: 'Eliza_cannonball_bed_with_storage',
    component: Eliza_cannonball_bed_with_storage,
  },
  {
    name: 'Eliza_cannonball_bed_with_storage',
    component: Eliza_cannonball_bed_with_storage,
  },
  { name: 'Elle_long_sofa', component: Elle_long_sofa },
  { name: 'Eloise_ottoman', component: Eloise_ottoman },
  { name: 'Evy_chair', component: Evy_chair },
  { name: 'Evy_ottoman', component: Evy_ottoman },
  { name: 'Extra_large_stowaway_shelf', component: Extra_large_stowaway_shelf },
  { name: 'Fiddlehead_cocktail_table', component: Fiddlehead_cocktail_table },
  { name: 'Fiddlehead_end_table', component: Fiddlehead_end_table },
  { name: 'Flora_chair', component: Flora_chair },
  { name: 'Flora_ottoman', component: Flora_ottoman },
  { name: 'Flora_wedge_sofa_x', component: Flora_wedge_sofa_x },
  { name: 'Francine_sofa_x', component: Francine_sofa_x },
  { name: 'Frannie_coffee_table', component: Frannie_coffee_table },
  {
    name: 'Frannie_farmhouse_dining_bench',
    component: Frannie_farmhouse_dining_bench,
  },
  {
    name: 'Frannie_farmhouse_dining_table',
    component: Frannie_farmhouse_dining_table,
  },
  { name: 'Freya_bench', component: Freya_bench },
  { name: 'Great_island_bookshelf', component: Great_island_bookshelf },
  { name: 'Gretchen_chair', component: Gretchen_chair },
  { name: 'Hailey_swivel_chair', component: Hailey_swivel_chair },
  { name: 'Hannah_blanket_chest', component: Hannah_blanket_chest },
  { name: 'Hannah_chair', component: Hannah_chair },
  { name: 'Harlow_wedge_sofa', component: Harlow_wedge_sofa },
  { name: 'Hazel_chair', component: Hazel_chair },
  { name: 'Hazel_chair', component: Hazel_chair },
  { name: 'Henry_chair', component: Henry_chair },
  { name: 'Henry_chair', component: Henry_chair },
  { name: 'High_tide_bed', component: High_tide_bed },
  { name: 'High_tide_bed', component: High_tide_bed },
  { name: 'High_tide_bed', component: High_tide_bed },
  { name: 'High_tide_bed', component: High_tide_bed },
  { name: 'Hooks_3', component: Hooks_3 },
  { name: 'Hooks_5', component: Hooks_5 },
  { name: 'Hutton_sofa', component: Hutton_sofa },
  { name: 'Ida_swivel_counter_stool', component: Ida_swivel_counter_stool },
  { name: 'Inga_trestle_dining_table', component: Inga_trestle_dining_table },
  { name: 'Inga_trestle_dining_table', component: Inga_trestle_dining_table },
  { name: 'Island_bed', component: Island_bed },
  { name: 'Island_bed', component: Island_bed },
  { name: 'Island_bed', component: Island_bed },
  { name: 'Island_bed', component: Island_bed },
  { name: 'Island_bedside_cabinet', component: Island_bedside_cabinet },
  { name: 'Island_bedside_cabinet', component: Island_bedside_cabinet },
  { name: 'Island_media_center', component: Island_media_center },
  { name: 'Island_settee', component: Island_settee },
  { name: 'Jack_dining_chair', component: Jack_dining_chair },
  { name: 'Jack_dining_chair', component: Jack_dining_chair },
  { name: 'James_ottoman', component: James_ottoman },
  { name: 'Jill_dining_chair', component: Jill_dining_chair },
  { name: 'Jill_dining_chair', component: Jill_dining_chair },
  { name: 'Joey_sofa', component: Joey_sofa },
  { name: 'Judy_bar_stool_natural', component: Judy_bar_stool_natural },
  { name: 'Judy_bar_stool_painted', component: Judy_bar_stool_painted },
  { name: 'Judy_counter_stool_natural', component: Judy_counter_stool_natural },
  { name: 'Judy_counter_stool_painted', component: Judy_counter_stool_painted },
  { name: 'Judy_dining_chair_natural', component: Judy_dining_chair_natural },
  { name: 'Judy_dining_chair_painted', component: Judy_dining_chair_painted },
  { name: 'Large_charlie_buffet', component: Large_charlie_buffet },
  { name: 'Large_margate_buffet', component: Large_margate_buffet },
  { name: 'Large_stowaway_shelf', component: Large_stowaway_shelf },
  { name: 'Largest_stowaway_shelf', component: Largest_stowaway_shelf },
  { name: 'Lattice_3drawer_dresser', component: Lattice_3drawer_dresser },
  { name: 'Lattice_bed', component: Lattice_bed },
  { name: 'Lattice_bed', component: Lattice_bed },
  { name: 'Lattice_bed', component: Lattice_bed },
  { name: 'Lattice_bed', component: Lattice_bed },
  { name: 'Lattice_day_bed', component: Lattice_day_bed },
  { name: 'Lattice_double_dresser', component: Lattice_double_dresser },
  {
    name: 'Lattice_tall_dresser_2over3',
    component: Lattice_tall_dresser_2over3,
  },
  { name: 'Lilah_swivel_chair', component: Lilah_swivel_chair },
  { name: 'Lillian_bench', component: Lillian_bench },
  { name: 'Little_cay_desk', component: Little_cay_desk },
  { name: 'Little_cay_desk', component: Little_cay_desk },
  { name: 'Lottie_dining_bench', component: Lottie_dining_bench },
  { name: 'Lottie_leaf_coffee_table', component: Lottie_leaf_coffee_table },
  { name: 'Lottie_leaf_console_table', component: Lottie_leaf_console_table },
  { name: 'Lottie_leaf_dining_table', component: Lottie_leaf_dining_table },
  { name: 'Lottie_leaf_stool', component: Lottie_leaf_stool },
  { name: 'Lottie_leaf_writing_desk', component: Lottie_leaf_writing_desk },
  { name: 'Lottie_side_table', component: Lottie_side_table },
  { name: 'Low_tide_day_bed', component: Low_tide_day_bed },
  { name: 'Low_tide_desk', component: Low_tide_desk },
  { name: 'Low_tide_hall_table', component: Low_tide_hall_table },
  { name: 'Mabel_bed', component: Mabel_bed },
  { name: 'Mabel_bed', component: Mabel_bed },
  { name: 'Mabel_bed', component: Mabel_bed },
  { name: 'Mabel_bed', component: Mabel_bed },
  { name: 'Margaret_bench', component: Margaret_bench },
  {
    name: 'Margate_bookshelf_with_doors',
    component: Margate_bookshelf_with_doors,
  },
  { name: 'Margate_dining_table', component: Margate_dining_table },
  { name: 'Margate_dining_table', component: Margate_dining_table },
  { name: 'Margate_dining_table', component: Margate_dining_table },
  {
    name: 'Margate_extension_dining_table',
    component: Margate_extension_dining_table,
  },
  {
    name: 'Margate_extension_dining_table',
    component: Margate_extension_dining_table,
  },
  { name: 'Margate_media_console', component: Margate_media_console },
  { name: 'Margot_chair', component: Margot_chair },
  { name: 'Max_chair', component: Max_chair },
  { name: 'Medium_stowaway_shelf', component: Medium_stowaway_shelf },
  { name: 'Meriweather_bed', component: Meriweather_bed },
  { name: 'Meriweather_bed', component: Meriweather_bed },
  { name: 'Meriweather_bed', component: Meriweather_bed },
  { name: 'Meriweather_bed', component: Meriweather_bed },
  { name: 'Mia_bench', component: Mia_bench },
  { name: 'Milly_storage_ottoman', component: Milly_storage_ottoman },
  { name: 'Milly_twin_sleeper_chair', component: Milly_twin_sleeper_chair },
  { name: 'Minnie_counter_stool', component: Minnie_counter_stool },
  { name: 'Molly_bench', component: Molly_bench },
  { name: 'Monty_sofa', component: Monty_sofa },
  { name: 'Morgan_ottoman', component: Morgan_ottoman },
  {
    name: 'Nellie_2drawer_bedside_table',
    component: Nellie_2drawer_bedside_table,
  },
  { name: 'Nellie_2over2dresser', component: Nellie_2over2dresser },
  { name: 'Nellie_3drawer_dresser', component: Nellie_3drawer_dresser },
  { name: 'Nellie_double_dresser', component: Nellie_double_dresser },
  { name: 'Nellie_end_table', component: Nellie_end_table },
  { name: 'Olivia_chair', component: Olivia_chair },
  { name: 'Oscar_chair', component: Oscar_chair },
  { name: 'Paige_bench', component: Paige_bench },
  { name: 'Piper_chair', component: Piper_chair },
  { name: 'Quinn_chair', component: Quinn_chair },
  { name: 'Quinn_chair', component: Quinn_chair },
  {
    name: 'Retreat_monterey_barrel_back_swivel_chair',
    component: Retreat_monterey_barrel_back_swivel_chair,
  },
  { name: 'Retreat_monterey_chair', component: Retreat_monterey_chair },
  { name: 'Retreat_monterey_sofa', component: Retreat_monterey_sofa },
  { name: 'Retreat_nantucket_chair', component: Retreat_nantucket_chair },
  {
    name: 'Retreat_nantucket_chair_and_a_half_sleeper',
    component: Retreat_nantucket_chair_and_a_half_sleeper,
  },
  { name: 'Retreat_nantucket_sofa', component: Retreat_nantucket_sofa },
  { name: 'Retreat_palm_beach_chair', component: Retreat_palm_beach_chair },
  { name: 'Ruben_hassock', component: Ruben_hassock },
  { name: 'Ruby_sound_cabinet', component: Ruby_sound_cabinet },
  { name: 'Shelby_bench', component: Shelby_bench },
  { name: 'Shelby_chair', component: Shelby_chair },
  { name: 'Shelby_ottoman', component: Shelby_ottoman },
  { name: 'Shelby_sofa', component: Shelby_sofa },
  { name: 'Shutter_bed', component: Shutter_bed },
  { name: 'Shutter_bed', component: Shutter_bed },
  { name: 'Shutter_bed', component: Shutter_bed },
  { name: 'Shutter_bed', component: Shutter_bed },
  { name: 'Signature_cord_welt_pillow', component: Signature_cord_welt_pillow },
  { name: 'Signature_kidney_pillow', component: Signature_kidney_pillow },
  { name: 'Skinniest_island_bookshelf', component: Skinniest_island_bookshelf },
  { name: 'Small_island_bookshelf', component: Small_island_bookshelf },
  { name: 'Small_margate_buffet', component: Small_margate_buffet },
  { name: 'Small_stowaway_shelf', component: Small_stowaway_shelf },
  { name: 'Smallest_island_bookshelf', component: Smallest_island_bookshelf },
  { name: 'Stevie_sofa_x', component: Stevie_sofa_x },
  { name: 'Suri_ottoman', component: Suri_ottoman },
  { name: 'Tall_stowaway_shelf', component: Tall_stowaway_shelf },
  { name: 'Tide_pool_hall_table', component: Tide_pool_hall_table },
  { name: 'Tide_pool_side_table', component: Tide_pool_side_table },
  { name: 'Tilly_chair', component: Tilly_chair },
  { name: 'Tilly_ottoman', component: Tilly_ottoman },
  { name: 'Topper_coffee_table', component: Topper_coffee_table },
  { name: 'Trundle_bed', component: Trundle_bed },
  { name: 'Tulla_tuffet_ottoman', component: Tulla_tuffet_ottoman },
  { name: 'Wendy_side_table', component: Wendy_side_table },
  { name: 'Wilton_skirted_ottoman', component: Wilton_skirted_ottoman },
  { name: 'Wilton_skirted_sofa', component: Wilton_skirted_sofa },
  { name: 'Wilton_skirtless_sofa', component: Wilton_skirtless_sofa },
  { name: 'Windsor_arm_chair_painted', component: Windsor_arm_chair_painted },
  { name: 'Flora_sofa_and_loveseat', component: Flora_sofa_and_loveseat, },
  {name: 'Windsor_dining_chair_painted', component: Windsor_dining_chair_painted}
];

// export const ProductData = [
//   {
//     id: 149,
//     product: Addy_2over3drawer_dresser,
//     title: 'Addy 2-Over-3-Drawer Dresser',
//     dimention: ['0.95', '0.475', '1.125'],
//     dimentionText: ['38"', '19"', '45"'],
//     uuid: '149',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 150,
//     product: Addy_3drawer_bedside_dresser,
//     title: 'Addy 3-Drawer Bedside Dresser',
//     dimention: ['0.575', '0.475', '0.9'],
//     dimentionText: ['23"', '19"', '32"'],
//     uuid: '150',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 151,
//     product: Addy_4over4drawer_dresser,
//     title: 'filename',
//     dimention: ['0.95', '0.475', '1.55'],
//     dimentionText: ['38"', '19"', '62"'],
//     uuid: '151',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 152,
//     product: Addy_bedside_cabinet,
//     title: 'Addy Bedside Cabinet',
//     dimention: ['0.575', '0.475', '0.8'],
//     dimentionText: ['23"', '19"', '32"'],
//     uuid: '152',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 249,
//     product: Addy_bedside_cabinet,
//     title: 'Addy Bedside Cabinet',
//     dimention: ['0.575', '0.475', '0.8'],
//     dimentionText: ['23"', '19"', '32"'],
//     uuid: '152',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 153,
//     product: Addy_blanket_chest,
//     title: 'Addy Blanket Chest',
//     dimention: ['0.95', '0.475', '0.625'],
//     dimentionText: ['38"', '19"', '25"'],
//     uuid: '153',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 154,
//     product: Addy_double_dresser_54,
//     title: 'Addy Double Dresser 54',
//     dimention: ['1.35', '0.475', '0.9125'],
//     dimentionText: ['54"', '19"', '36.5"'],
//     uuid: '154',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 155,
//     product: Addy_double_dresser_65,
//     title: 'Addy Double Dresser 65',
//     dimention: ['1.625', '0.475', '0.9125'],
//     dimentionText: ['65"', '19"', '36.5"'],
//     uuid: '155',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 156,
//     product: Addy_hideaway_dresser,
//     title: 'Addy Hideaway Dresser',
//     dimention: ['1.4', '0.475', '1.2875'],
//     dimentionText: ['56"', '19"', '51.5"'],
//     uuid: '156',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 157,
//     product: Addy_lingerie_dresser,
//     title: 'Addy Lingerie Dresser',
//     dimention: ['0.575', '0.475', '1.5'],
//     dimentionText: ['23"', '19"', '60"'],
//     uuid: '157',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 181,
//     product: Addy_side_table,
//     title: 'Addy Side Table',
//     dimention: ['0.5', '0.5', '0.75'],
//     dimentionText: ['20"', '20"', '30"'],
//     uuid: '181',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 182,
//     product: Addy_side_table_with_shelf,
//     title: 'Addy Side Table with Shelf',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 183,
//     product: Amelia_side_table,
//     title: 'Amelia Side Table',
//     dimention: ['0.425', '0.5', '0.75'],
//     dimentionText: ['17"', '20"', '30"'],
//     uuid: '183',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 81,
//     product: Annie_bed,
//     title: 'Annie Bed',
//     dimention: ['1.05', '2.075', '1.5'],
//     dimentionText: ['42"', '83"', '60"'],
//     uuid: '81',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 232,
//     product: Annie_bed,
//     title: 'Annie Bed',
//     dimention: ['1.6', '2.2', '1.5'],
//     dimentionText: ['64"', '88"', '60"'],
//     uuid: '81',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 233,
//     product: Annie_bed,
//     title: 'Annie Bed',
//     dimention: ['2', '2.2', '1.5'],
//     dimentionText: ['80"', '88"', '60"'],
//     uuid: '81',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 3,
//     product: Astrid_chair,
//     title: 'Astrid Chair',
//     dimention: ['0.825', '0.825', '0.775'],
//     dimentionText: ['33"', '33"', '31"'],
//     uuid: '3',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 4,
//     product: Barrett_bamboo_arm_chair,
//     title: 'Barrett Bamboo Arm Chair',
//     dimention: ['0.575', '0.575', '0.9125'],
//     dimentionText: ['23"', '23"', '36.5"'],
//     uuid: '4',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legPaintColorFinish: 'Nordic',
//     },
//   },
//   {
//     id: 5,
//     product: Barrett_bamboo_chair,
//     title: 'Barrett Bamboo Chair',
//     dimention: ['0.4625', '0.525', '0.9125'],
//     dimentionText: ['18.5"', '21"', '36.5"'],
//     uuid: '5',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legPaintColorFinish: 'Nordic',
//     },
//   },
//   {
//     id: 159,
//     product: Bay_2over4dresser,
//     title: 'Bay 2-Over-4-Dresser',
//     dimention: ['0.925', '0.525', '1.35'],
//     dimentionText: ['37"', '21"', '54"'],
//     uuid: '159',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 158,
//     product: Bay_3drawer_dresser,
//     title: 'Bay 3-Drawer Dresser',
//     dimention: ['0.5', '0.35', '0.725'],
//     dimentionText: ['20"', '14"', '29"'],
//     uuid: '158',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 184,
//     product: Bay_bedside_cabnet,
//     title: 'Bay Bedside Cabinet',
//     dimention: ['0.5', '0.35', '0.725'],
//     dimentionText: ['20"', '14"', '29"'],
//     uuid: '184',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 250,
//     product: Bay_bedside_cabnet,
//     title: 'Bay Bedside Cabnet',
//     dimention: ['0.5', '0.35', '0.725'],
//     dimentionText: ['20"', '14"', '29"'],
//     uuid: '184',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Vast Sky',
//     },
//   },
//   {
//     id: 174,
//     product: Bay_double_window_seat,
//     title: 'Bay Double Window Seat',
//     dimention: ['1.55', '0.5', '0.45'],
//     dimentionText: ['62"', '20"', '18"'],
//     uuid: '174',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 199,
//     product: Bed_bin,
//     title: 'Bed Bin',
//     dimention: ['0.787', '0.787', '0.263'],
//     dimentionText: ['31.5"', '31.5"', '10.5"'],
//     uuid: '199',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 168,
//     product: Big_cay_desk,
//     title: 'Big Cay Desk',
//     dimention: ['1.6', '0.6', '0.75'],
//     dimentionText: ['64"', '24"', '30"'],
//     uuid: '168',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 169,
//     product: Big_cay_desk_with_library_hutch,
//     title: 'Big Cay Desk with Library Hutch',
//     dimention: ['1.625', '0.6', '1.775'],
//     dimentionText: ['65"', '24"', '71"'],
//     uuid: '169',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 6,
//     product: Billie_chair,
//     title: 'Billie Chair',
//     dimention: ['0.625', '0.625', '0.775'],
//     dimentionText: ['25"', '25"', '31"'],
//     uuid: '6',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 40,
//     product: Blair_sofa,
//     title: 'Blair Sofa',
//     dimention: ['2.237', '1.1', '0.787'],
//     dimentionText: ['89.5"', '44"', '31.5"'],
//     uuid: '40',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 95,
//     product: Blanche_oval_coffee_table_with_scallops,
//     title: 'Blanche Oval Coffee Table with Scallops',
//     dimention: ['1.2', '0.75', '0.475'],
//     dimentionText: ['48"', '30"', '19"'],
//     uuid: '95',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 185,
//     product: Bloom_tea_table,
//     title: 'Bloom Tea Table',
//     dimention: ['0.625', '0.3', '0.3'],
//     dimentionText: ['25"', '12"', '12"'],
//     uuid: '185',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 96,
//     product: Boat_hull_coffee_table,
//     title: 'Boat Hull Coffee Table',
//     dimention: ['1.05', '1.05', '0.475'],
//     dimentionText: ['42"', '42"', '19"'],
//     uuid: '96',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Natural Maple',
//     },
//   },
//   {
//     id: 97,
//     product: Boat_hull_hall_table,
//     title: 'Boat Hull Hall Table',
//     dimention: ['1.393', '0.525', '0.525'],
//     dimentionText: ['55.75"', '21"', '21"'],
//     uuid: '97',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Natural Maple',
//     },
//   },
//   {
//     id: 112,
//     product: Boothbay_dining_chair_natural,
//     title: 'Boothbay Dining Chair - Natural',
//     dimention: ['0.475', '0.5', '0.85'],
//     dimentionText: ['19"', '20"', '34"'],
//     uuid: '112',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       chairFrameFinish: 'Natural Maple',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 113,
//     product: Boothbay_dining_chair_painted,
//     title: 'Boothbay Dining Chair - Painted',
//     dimention: ['0.475', '0.5', '0.85'],
//     dimentionText: ['19"', '20"', '34"'],
//     uuid: '113',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 111,
//     product: Boothbay_dining_cushion_only,
//     title: 'Boothbay Dining Cushion ONLY',
//     dimention: ['0.5', '0.6', '0.09625'],
//     dimentionText: ['20"', '24"', '3.85"'],
//     uuid: '111',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 139,
//     product: Breakers_card_table,
//     title: 'Breakers Card Table',
//     dimention: ['1.16', '1.16', '0.75'],
//     dimentionText: ['46"', '46"', '30"'],
//     uuid: '139',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 140,
//     product: Breakers_dining_table,
//     title: 'Breakers Dining Table',
//     dimention: ['0.825', '1.5', '0.75'],
//     dimentionText: ['33"', '60"', '30"'],
//     uuid: '140',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 274,
//     product: Breakers_dining_table,
//     title: 'Breakers Dining Table',
//     dimention: ['0.9', '1.8', '0.75'],
//     dimentionText: ['36"', '72"', '30"'],
//     uuid: '140',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 275,
//     product: Breakers_dining_table,
//     title: 'Breakers Dining Table',
//     dimention: ['1', '2.1', '0.75'],
//     dimentionText: ['40"', '84"', '30"'],
//     uuid: '140',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 141,
//     product: Breakers_extension_dining_table,
//     title: 'Breakers Extension Dining Table',
//     dimention: ['1.1', '1.8', '0.75'],
//     dimentionText: ['44"', '72" to 92"', '30"'],
//     uuid: '141',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 276,
//     product: Breakers_extension_dining_table,
//     title: 'Breakers Extension Dining Table',
//     dimention: ['1.1', '1.8', '0.75'],
//     dimentionText: ['44"', '72" to 110"', '30"'],
//     uuid: '141',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 98,
//     product: Cable_lock_coffee_table,
//     title: 'Cable Lock Coffee Table',
//     dimention: ['0.85', '0.85', '0.45'],
//     dimentionText: ['34"', '34"', '18"'],
//     uuid: '98',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 99,
//     product: Cable_lock_dining_bench,
//     title: 'Cable Lock Dining Bench',
//     dimention: ['1.2', '0.35', '0.45'],
//     dimentionText: ['48"', '14"', '18"'],
//     uuid: '99',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 270,
//     product: Cable_lock_dining_bench,
//     title: 'Cable Lock Dining Bench',
//     dimention: ['1.5', '0.35', '0.45'],
//     dimentionText: ['60"', '14"', '18"'],
//     uuid: '99',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 271,
//     product: Cable_lock_dining_bench,
//     title: 'Cable Lock Dining Bench',
//     dimention: ['1.8', '0.35', '0.45'],
//     dimentionText: ['72"', '14"', '18"'],
//     uuid: '99',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 142,
//     product: Cable_lock_dining_table,
//     title: 'Cable Lock Dining Table',
//     dimention: ['1.05', '1.7', '0.75'],
//     dimentionText: ['42"', '68"', '30"'],
//     uuid: '142',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 272,
//     product: Cable_lock_dining_table,
//     title: 'Cable Lock Dining Table',
//     dimention: ['1.05', '2', '0.75'],
//     dimentionText: ['42"', '80"', '30"'],
//     uuid: '142',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 273,
//     product: Cable_lock_dining_table,
//     title: 'Cable Lock Dining Table',
//     dimention: ['1.05', '2.3', '0.75'],
//     dimentionText: ['42"', '92"', '30"'],
//     uuid: '142',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 100,
//     product: Cable_lock_end_table,
//     title: 'Cable Lock End Table',
//     dimention: ['0.6', '0.5', '0.625'],
//     dimentionText: ['24"', '20"', '25"'],
//     uuid: '100',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 101,
//     product: Cable_lock_hall_table,
//     title: 'Cable Lock Hall Table',
//     dimention: ['1.5', '0.4', '0.725'],
//     dimentionText: ['60"', '16"', '29"'],
//     uuid: '101',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 82,
//     product: Calvin_bed,
//     title: 'Calvin Bed',
//     dimention: ['1.05', '2', '2'],
//     dimentionText: ['42"', '80"', '80"'],
//     uuid: '82',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 234,
//     product: Calvin_bed,
//     title: 'Calvin Bed',
//     dimention: ['1.44', '2', '2'],
//     dimentionText: ['57.75"', '80"', '80"'],
//     uuid: '82',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 235,
//     product: Calvin_bed,
//     title: 'Calvin Bed',
//     dimention: ['1.59', '2.12', '2'],
//     dimentionText: ['63.75"', '85"', '80"'],
//     uuid: '82',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 236,
//     product: Calvin_bed,
//     title: 'Calvin Bed',
//     dimention: ['1.99', '2.15', '2'],
//     dimentionText: ['79.75"', '86"', '80"'],
//     uuid: '82',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 186,
//     product: Castanet_stool,
//     title: 'Cast-a-Net Stool',
//     dimention: ['0.475', '0.425', '0.425'],
//     dimentionText: ['19"', '17"', '17"'],
//     uuid: '186',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 200,
//     product: Charlie_media_console,
//     title: 'Charlie Media Console',
//     dimention: ['1.2', '0.375', '1'],
//     dimentionText: ['48"', '15"', '40"'],
//     uuid: '200',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 187,
//     product: Charlie_round_side_table,
//     title: 'Charlie Round Side Table',
//     dimention: ['0.525', '0.525', '0.7'],
//     dimentionText: ['21"', '21"', '28"'],
//     uuid: '187',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 160,
//     product: Charlotte_2over3_drawer_dresser,
//     title: 'Charlotte 2-Over-3 Drawer Dresser',
//     dimention: ['0.95', '0.475', '1.125'],
//     dimentionText: ['38"', '19"', '45"'],
//     uuid: '160',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 229,
//     product: Charlotte_2over3_drawer_dresser,
//     title: 'Charlotte 2-Over-3 Drawer Dresser',
//     dimention: ['0.95', '0.475', '1.125'],
//     dimentionText: ['38"', '19"', '45"'],
//     uuid: '160',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 161,
//     product: Charlotte_3_drawer_dresser,
//     title: 'Charlotte 3 Drawer Dresser',
//     dimention: ['0.95', '0.475', '0.95'],
//     dimentionText: ['38"', '19"', '38"'],
//     uuid: '161',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 220,
//     product: Charlotte_3_drawer_dresser,
//     title: 'Charlotte 3 Drawer Dresser',
//     dimention: ['0.95', '0.475', '0.95'],
//     dimentionText: ['38"', '19"', '38"'],
//     uuid: '161',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 83,
//     product: Charlotte_bed,
//     title: 'Charlotte Bed',
//     dimention: ['1.043', '1.99', '1.306'],
//     dimentionText: ['41.75"', '79.5"', '52.25"'],
//     uuid: '83',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       headboardFabricFinish: 'Freckles : Skyline',
//     },
//   },
//   {
//     id: 237,
//     product: Charlotte_bed,
//     title: 'Charlotte Bed',
//     dimention: ['1.44', '1.99', '1.306'],
//     dimentionText: ['57.75"', '79.5"', '52.25"'],
//     uuid: '83',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       headboardFabricFinish: 'Freckles : Skyline',
//     },
//   },
//   {
//     id: 238,
//     product: Charlotte_bed,
//     title: 'Charlotte Bed',
//     dimention: ['1.6', '1.99', '1.306'],
//     dimentionText: ['63.75"', '79.5"', '52.25"'],
//     uuid: '83',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       headboardFabricFinish: 'Freckles : Skyline',
//     },
//   },
//   {
//     id: 239,
//     product: Charlotte_bed,
//     title: 'Charlotte Bed',
//     dimention: ['1.99', '1.99', '1.306'],
//     dimentionText: ['79.75"', '79.5"', '52.25"'],
//     uuid: '83',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       headboardFabricFinish: 'Freckles : Skyline',
//     },
//   },
//   {
//     id: 162,
//     product: Charlotte_bedside_dresser,
//     title: 'Charlotte Bedside Dresser',
//     dimention: ['0.75', '0.475', '0.75'],
//     dimentionText: ['30"', '19"', '30"'],
//     uuid: '162',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 219,
//     product: Charlotte_bedside_dresser,
//     title: 'Charlotte Bedside Dresser',
//     dimention: ['0.75', '0.475', '0.75'],
//     dimentionText: ['30"', '19"', '30"'],
//     uuid: '162',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 163,
//     product: Charlotte_double_dresser,
//     title: 'Charlotte Double Dresser',
//     dimention: ['1.65', '0.475', '0.95'],
//     dimentionText: ['66"', '19"', '38"'],
//     uuid: '163',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 228,
//     product: Charlotte_double_dresser,
//     title: 'Charlotte Double Dresser',
//     dimention: ['1.65', '0.475', '0.95'],
//     dimentionText: ['66"', '19"', '38"'],
//     uuid: '163',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 176,
//     product: Chesapeake_bench,
//     title: 'Chesapeake Bench',
//     dimention: ['1.2', '0.537', '0.475'],
//     dimentionText: ['48"', '21.5"', '19"'],
//     uuid: '176',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 102,
//     product: Chesapeake_coffee_table,
//     title: 'Chesapeake Coffee Table',
//     dimention: ['0.8', '0.5375', '0.475'],
//     dimentionText: ['32"', '21.5"', '19"'],
//     uuid: '102',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 188,
//     product: Chesapeake_end_table,
//     title: 'Chesapeake End Table',
//     dimention: ['0.45', '0.45', '0.65'],
//     dimentionText: ['18"', '18"', '26"'],
//     uuid: '188',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 189,
//     product: Classic_cottage_sofa_table,
//     title: 'Classic Cottage Sofa Table',
//     dimention: ['0.6', '0.6', '0.625'],
//     dimentionText: ['24"', '24"', '25"'],
//     uuid: '189',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 190,
//     product: Classic_maine_cottage_end_table,
//     title: 'Classic Maine Cottage End Table',
//     dimention: ['0.475', '0.55', '0.7'],
//     dimentionText: ['19"', '22"', '28"'],
//     uuid: '190',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 114,
//     product: Cokie_barstool_natural,
//     title: 'Cokie Barstool - Natural',
//     dimention: ['0.5', '0.55', '1.125'],
//     dimentionText: ['20"', '22"', '45"'],
//     uuid: '114',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       chairFrameFinish: 'Natural Maple',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 115,
//     product: Cokie_barstool_painted,
//     title: 'Cokie Barstool - Painted',
//     dimention: ['0.5', '0.55', '1.125'],
//     dimentionText: ['20"', '22"', '45"'],
//     uuid: '115',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 116,
//     product: Cokie_counter_stool_natural,
//     title: 'Cokie Counter Stool - Natural',
//     dimention: ['0.5', '0.55', '1.025'],
//     dimentionText: ['20"', '22"', '41"'],
//     uuid: '116',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       chairFrameFinish: 'Natural Maple',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 117,
//     product: Cokie_counter_stool_painted,
//     title: 'Cokie Counter Stool - Painted',
//     dimention: ['0.5', '0.55', '1.025'],
//     dimentionText: ['20"', '22"', '41"'],
//     uuid: '117',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 170,
//     product: Cokie_desk_chair,
//     title: 'Cokie Desk Chair',
//     dimention: ['0.6375', '0.6875', '0.95'],
//     dimentionText: ['25.5"', '27.5"', '38"'],
//     uuid: '170',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 118,
//     product: Cokie_desk_chair_natural,
//     title: 'Cokie Desk Chair - Natural',
//     dimention: ['0.6375', '0.6875', '0.95'],
//     dimentionText: ['25.5"', '27.5"', '38"'],
//     uuid: '118',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       chairFrameFinish: 'Natural Maple',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 119,
//     product: Cokie_desk_chair_painted,
//     title: 'Cokie Desk Chair - Painted',
//     dimention: ['0.6375', '0.6875', '0.95'],
//     dimentionText: ['25.5"', '27.5"', '38"'],
//     uuid: '119',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 120,
//     product: Cokie_dining_chair_natural,
//     title: 'Cokie Dining Chair - Natural',
//     dimention: ['0.55', '0.55', '0.9'],
//     dimentionText: ['20"', '22"', '36"'],
//     uuid: '120',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       chairFrameFinish: 'Natural Maple',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 121,
//     product: Cokie_dining_chair_painted,
//     title: 'Cokie Dining Chair - Painted',
//     dimention: ['0.5', '0.55', '0.9'],
//     dimentionText: ['20"', '22"', '36"'],
//     uuid: '121',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 57,
//     product: Cube_ottoman,
//     title: 'Cube Ottoman',
//     dimention: ['0.5', '0.5', '0.512'],
//     dimentionText: ['20"', '20"', '20.5"'],
//     uuid: '57',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 7,
//     product: Daphne_chair,
//     title: 'Daphne Chair',
//     dimention: ['0.625', '0.625', '0.775'],
//     dimentionText: ['25"', '25"', '31"'],
//     uuid: '7',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 41,
//     product: Daphne_long_sofa_x,
//     title: 'Daphne Long Sofa - X',
//     dimention: ['2.325', '0.975', '0.925'],
//     dimentionText: ['93"', '39"', '37"'],
//     uuid: '41',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 58,
//     product: Daphne_ottoman,
//     title: 'Daphne Ottoman',
//     dimention: ['0.625', '0.5', '0.45'],
//     dimentionText: ['25"', '20"', '18"'],
//     uuid: '58',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 42,
//     product: Daphne_sofa_x,
//     title: 'Daphne Sofa - X',
//     dimention: ['2.1', '0.975', '0.925'],
//     dimentionText: ['84"', '39"', '37"'],
//     uuid: '42',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 103,
//     product: Della_cocktail_table,
//     title: 'Della Cocktail Table',
//     dimention: ['1.05', '1.05', '0.45'],
//     dimentionText: ['42"', '42"', '18"'],
//     uuid: '103',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 143,
//     product: Della_dining_table,
//     title: 'Della Dining Table',
//     dimention: ['0.9', '0.9', '0.75'],
//     dimentionText: ['36"', '36"', '30"'],
//     uuid: '143',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 278,
//     product: Della_dining_table,
//     title: 'Della Dining Table',
//     dimention: ['1.2', '1.2', '0.75'],
//     dimentionText: ['48"', '48"', '30"'],
//     uuid: '143',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 279,
//     product: Della_dining_table,
//     title: 'Della Dining Table',
//     dimention: ['1.5', '1.5', '0.75'],
//     dimentionText: ['60"', '60"', '30"'],
//     uuid: '143',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 122,
//     product: Edna_dining_chair_natural,
//     title: 'Edna Dining Chair - Natural',
//     dimention: ['0.48125', '0.5', '0.925'],
//     dimentionText: ['19.25"', '20"', '37"'],
//     uuid: '122',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       chairFrameFinish: 'Natural Maple',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 123,
//     product: Edna_dining_chair_painted,
//     title: 'Edna Dining Chair - Painted',
//     dimention: ['0.48125', '0.5', '0.925'],
//     dimentionText: ['19.25"', '20"', '37"'],
//     uuid: '123',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 8,
//     product: Eleanor_chair,
//     title: 'Eleanor Chair',
//     dimention: ['0.775', '0.925', '0.975'],
//     dimentionText: ['31"', '37"', '39"'],
//     uuid: '8',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legPaintColorFinish: 'Nordic',
//     },
//   },
//   {
//     id: 59,
//     product: Eleanor_ottoman,
//     title: 'Eleanor Ottoman',
//     dimention: ['0.7', '0.525', '0.5'],
//     dimentionText: ['28"', '21"', '20"'],
//     uuid: '59',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legPaintColorFinish: 'Nordic',
//     },
//   },
//   {
//     id: 84,
//     product: Eliza_cannonball_bed_with_storage,
//     title: 'Eliza Cannonball Bed with Storage',
//     dimention: ['1.45', '2.1', '1.5'],
//     dimentionText: ['58"', '84"', '60"'],
//     uuid: '84',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 240,
//     product: Eliza_cannonball_bed_with_storage,
//     title: 'Eliza Cannonball Bed with Storage',
//     dimention: ['1.6', '2.225', '1.5'],
//     dimentionText: ['64"', '89"', '60"'],
//     uuid: '84',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 241,
//     product: Eliza_cannonball_bed_with_storage,
//     title: 'Eliza Cannonball Bed with Storage',
//     dimention: ['2', '2.225', '1.5'],
//     dimentionText: ['80"', '89"', '60"'],
//     uuid: '84',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 43,
//     product: Elle_long_sofa,
//     title: 'Elle Long Sofa',
//     dimention: ['2.35', '0.925', '0.825'],
//     dimentionText: ['94"', '37"', '33"'],
//     uuid: '43',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 60,
//     product: Eloise_ottoman,
//     title: 'Eloise Ottoman',
//     dimention: ['0.7', '0.7', '0.475'],
//     dimentionText: ['28"', '28"', '19"'],
//     uuid: '60',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 9,
//     product: Evy_chair,
//     title: 'Evy Chair',
//     dimention: ['0.825', '0.975', '0.975'],
//     dimentionText: ['33"', '39"', '39"'],
//     uuid: '9',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//     },
//   },
//   {
//     id: 61,
//     product: Evy_ottoman,
//     title: 'Evy Ottoman',
//     dimention: ['0.7', '0.55', '0.425'],
//     dimentionText: ['28"', '22"', '17"'],
//     uuid: '61',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//     },
//   },
//   {
//     id: 201,
//     product: Extra_large_stowaway_shelf,
//     title: 'Extra Large Stow-Away Shelf',
//     dimention: ['1.175', '0.35', '1.3'],
//     dimentionText: ['47"', '14"', '52"'],
//     uuid: '201',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 104,
//     product: Fiddlehead_cocktail_table,
//     title: 'Fiddlehead Cocktail Table',
//     dimention: ['0.95', '0.95', '0.55'],
//     dimentionText: ['38"', '38"', '22"'],
//     uuid: '104',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 191,
//     product: Fiddlehead_end_table,
//     title: 'Fiddlehead End Table',
//     dimention: ['0.8', '0.625', '0.625'],
//     dimentionText: ['32"', '25"', '25"'],
//     uuid: '191',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 10,
//     product: Flora_chair,
//     title: 'Flora Chair',
//     dimention: ['0.875', '0.95', '0.95'],
//     dimentionText: ['35"', '38"', '38"'],
//     uuid: '10',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//     },
//   },
//   {
//     id: 62,
//     product: Flora_ottoman,
//     title: 'Flora Ottoman',
//     dimention: ['0.725', '0.6', '0.475'],
//     dimentionText: ['29"', '24"', '19"'],
//     uuid: '62',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//     },
//   },
//   {
//     id: 44,
//     product: Flora_sofa_and_loveseat,
//     title: 'Flora Sofa (and loveseat)',
//     dimention: ['2.1', '0.95', '0.95'],
//     dimentionText: ['84"', '38"', '38"'],
//     uuid: '44',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//     },
//   },
//   {
//     id: 45,
//     product: Flora_wedge_sofa_x,
//     title: 'Flora Wedge Sofa - X',
//     dimention: ['2.875', '1.275', '0.95'],
//     dimentionText: ['115"', '51"', '38"'],
//     uuid: '45',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//     },
//   },
//   {
//     id: 46,
//     product: Francine_sofa_x,
//     title: 'Francine Sofa - X',
//     dimention: ['2.175', '0.9', '0.9'],
//     dimentionText: ['87"', '36"', '36"'],
//     uuid: '46',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 105,
//     product: Frannie_coffee_table,
//     title: 'Frannie Coffee Table',
//     dimention: ['1.2', '1.2', '0.475'],
//     dimentionText: ['48"', '48"', '19"'],
//     uuid: '105',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 177,
//     product: Frannie_farmhouse_dining_bench,
//     title: 'Frannie Farmhouse Dining Bench',
//     dimention: ['1.3', '0.45', '0.475'],
//     dimentionText: ['52"', '18"', '19"'],
//     uuid: '177',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 144,
//     product: Frannie_farmhouse_dining_table,
//     title: 'Frannie Farmhouse Dining Table',
//     dimention: ['1.8', '1', '0.75'],
//     dimentionText: ['72"', '40"', '30"'],
//     uuid: '144',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 63,
//     product: Freya_bench,
//     title: 'Freya Bench',
//     dimention: ['0.775', '0.525', '0.537'],
//     dimentionText: ['31"', '21"', '21.5"'],
//     uuid: '63',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 202,
//     product: Great_island_bookshelf,
//     title: 'Great Island Bookshelf',
//     dimention: ['0.85', '0.375', '1.675'],
//     dimentionText: ['34"', '15"', '67"'],
//     uuid: '202',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 11,
//     product: Gretchen_chair,
//     title: 'Gretchen Chair',
//     dimention: ['0.825', '0.825', '0.775'],
//     dimentionText: ['33"', '33"', '31"'],
//     uuid: '11',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Leaflette : Porch',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 12,
//     product: Hailey_swivel_chair,
//     title: 'Hailey Swivel Chair',
//     dimention: ['0.75', '0.9375', '0.7875'],
//     dimentionText: ['30"', '37.5"', '31.5"'],
//     uuid: '12',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 164,
//     product: Hannah_blanket_chest,
//     title: 'Hannah Blanket Chest',
//     dimention: ['0.85', '0.4', '0.45'],
//     dimentionText: ['34"', '16"', '18"'],
//     uuid: '164',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 13,
//     product: Hannah_chair,
//     title: 'Hannah Chair',
//     dimention: ['0.75', '0.9', '0.9375'],
//     dimentionText: ['30"', '36"', '37.5"'],
//     uuid: '13',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 47,
//     product: Harlow_wedge_sofa,
//     title: 'Harlow Wedge Sofa',
//     dimention: ['2.1', '0.95', '0.95'],
//     dimentionText: ['84"', '38"', '38"'],
//     uuid: '47',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 14,
//     product: Hazel_chair,
//     title: 'Hazel Chair',
//     dimention: ['0.725', '0.8', '0.825'],
//     dimentionText: ['29"', '32"', '33"'],
//     uuid: '14',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 230,
//     product: Hazel_chair,
//     title: 'Hazel Chair',
//     dimention: ['0.725', '0.8', '0.825'],
//     dimentionText: ['29"', '32"', '33"'],
//     uuid: '14',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 15,
//     product: Henry_chair,
//     title: 'Henry Chair',
//     dimention: ['0.687', '0.875', '0.85'],
//     dimentionText: ['27.5"', '35"', '34"'],
//     uuid: '15',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 231,
//     product: Henry_chair,
//     title: 'Henry Chair',
//     dimention: ['0.68725', '0.875', '0.85'],
//     dimentionText: ['27.5"', '35"', '34"'],
//     uuid: '15',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 85,
//     product: High_tide_bed,
//     title: 'High Tide Bed',
//     dimention: ['1.093', '2', '2'],
//     dimentionText: ['43.75"', '80"', '80"'],
//     uuid: '85',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 242,
//     product: High_tide_bed,
//     title: 'High Tide Bed',
//     dimention: ['1.44', '2', '2'],
//     dimentionText: ['57.75"', '80"', '80"'],
//     uuid: '85',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 243,
//     product: High_tide_bed,
//     title: 'High Tide Bed',
//     dimention: ['1.6', '2.125', '2'],
//     dimentionText: ['63.75"', '85"', '80"'],
//     uuid: '85',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 244,
//     product: High_tide_bed,
//     title: 'High Tide Bed',
//     dimention: ['1.99', '2.125', '2'],
//     dimentionText: ['79.75"', '88"', '80"'],
//     uuid: '85',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 86,
//     product: High_tide_bunk_bed,
//     title: 'High Tide Bunk Bed',
//     dimention: ['1.04375', '2', '1.825'],
//     dimentionText: ['41.75"', '80"', '73"'],
//     uuid: '86',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 79,
//     product: Hooks_3,
//     title: 'Hooks - 3',
//     dimention: ['0.6', '0.025', '0.2'],
//     dimentionText: ['24"', '1"', '8"'],
//     uuid: '79',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 80,
//     product: Hooks_5,
//     title: 'Hooks - 5',
//     dimention: ['1', '0.025', '0.2'],
//     dimentionText: ['40"', '1"', '8"'],
//     uuid: '80',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 16,
//     product: Hutton_chair,
//     title: 'Hutton Chair',
//     dimention: ['0.875', '0.975', '0.875'],
//     dimentionText: ['35"', '39"', '35"'],
//     uuid: '16',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 48,
//     product: Hutton_sofa,
//     title: 'Hutton Sofa',
//     dimention: ['2.112', '0.975', '0.875'],
//     dimentionText: ['84.5"', '39"', '35"'],
//     uuid: '48',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 124,
//     product: Ida_swivel_counter_stool,
//     title: 'Ida Swivel Counter Stool',
//     dimention: ['0.5', '0.5625', '1.1'],
//     dimentionText: ['20"', '22.5"', '44"'],
//     uuid: '124',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 145,
//     product: Inga_trestle_dining_table,
//     title: 'Inga Trestle Dining Table',
//     dimention: ['1.8', '1.05', '0.75'],
//     dimentionText: ['72"', '42"', '30"'],
//     uuid: '145',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 280,
//     product: Inga_trestle_dining_table,
//     title: 'Inga Trestle Dining Table',
//     dimention: ['2.1', '1.1', '0.75'],
//     dimentionText: ['84"', '44"', '30"'],
//     uuid: '145',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 87,
//     product: Island_bed,
//     title: 'Island Bed',
//     dimention: ['1.05', '2', '1.275'],
//     dimentionText: ['42"', '80"', '51"'],
//     uuid: '87',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 258,
//     product: Island_bed,
//     title: 'Island Bed',
//     dimention: ['1.44', '2', '1.275'],
//     dimentionText: ['57.75"', '80"', '51"'],
//     uuid: '87',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 259,
//     product: Island_bed,
//     title: 'Island Bed',
//     dimention: ['1.6', '2.125', '1.275'],
//     dimentionText: ['63.75"', '85"', '51"'],
//     uuid: '87',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 260,
//     product: Island_bed,
//     title: 'Island Bed',
//     dimention: ['1.99', '2.125', '1.275'],
//     dimentionText: ['79.75"', '86"', '51"'],
//     uuid: '87',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 192,
//     product: Island_bedside_cabinet,
//     title: 'Island Bedside Cabinet',
//     dimention: ['0.5', '0.35', '0.765'],
//     dimentionText: ['20"', '14"', '31"'],
//     uuid: '192',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 251,
//     product: Island_bedside_cabinet,
//     title: 'Island Bedside Cabinet',
//     dimention: ['0.5', '0.35', '0.765'],
//     dimentionText: ['20"', '14"', '31"'],
//     uuid: '192',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 203,
//     product: Island_media_center,
//     title: 'Island Media Center',
//     dimention: ['1.6', '0.55', '0.65'],
//     dimentionText: ['64"', '22"', '26"'],
//     uuid: '203',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 88,
//     product: Island_settee,
//     title: 'Island Settee',
//     dimention: ['2.025', '1.05', '1.025'],
//     dimentionText: ['81"', '42"', '41"'],
//     uuid: '88',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 125,
//     product: Jack_counter_stool,
//     title: 'Jack Counter Stool',
//     dimention: ['0.5', '0.6375', '1.2125'],
//     dimentionText: ['20"', '25.5"', '48.5"'],
//     uuid: '125',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 55,
//     product: Jack_dining_chair,
//     title: 'Jack Dining Chair',
//     dimention: ['0.5', '0.6', '0.962'],
//     dimentionText: ['20"', '24"', '38.5"'],
//     uuid: '55',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 221,
//     product: Jack_dining_chair,
//     title: 'Jack Dining Chair',
//     dimention: ['0.5', '0.6', '0.962'],
//     dimentionText: ['20"', '24"', '38.5"'],
//     uuid: '221',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 64,
//     product: James_ottoman,
//     title: 'James Ottoman',
//     modelWidth: null,
//     modelDepth: null,
//     modelHeight: null,
//     textWidth: null,
//     textDepth: null,
//     textHeight: null,
//     uuid: '64',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 56,
//     product: Jill_dining_chair,
//     title: 'Jill Dining Chair',
//     dimention: ['0.575', '0.675', '0.95'],
//     dimentionText: ['23"', '27"', '38"'],
//     uuid: '56',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 222,
//     product: Jill_dining_chair,
//     title: 'Jill Dining Chair',
//     dimention: ['0.575', '0.675', '0.95'],
//     dimentionText: ['23"', '27"', '38"'],
//     uuid: '222',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 49,
//     product: Joey_sofa,
//     title: 'Joey Sofa',
//     dimention: ['2.1', '1', '0.875'],
//     dimentionText: ['84"', '40"', '35"'],
//     uuid: '49',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 126,
//     product: Judy_bar_stool_natural,
//     title: 'Judy Bar Stool - Natural',
//     dimention: ['0.51875', '0.5', '1.075'],
//     dimentionText: ['20.75"', '20"', '43"'],
//     uuid: '126',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       chairFrameFinish: 'Natural Maple',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 127,
//     product: Judy_bar_stool_painted,
//     title: 'Judy Bar Stool - Painted',
//     dimention: ['0.51875', '0.5', '1.075'],
//     dimentionText: ['20.75"', '20"', '43"'],
//     uuid: '127',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Natural Maple',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 128,
//     product: Judy_counter_stool_natural,
//     title: 'Judy Counter Stool - Natural',
//     dimention: ['0.51875', '0.5', '0.925'],
//     dimentionText: ['20.75"', '20"', '37"'],
//     uuid: '128',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       chairFrameFinish: 'Natural Maple',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 129,
//     product: Judy_counter_stool_painted,
//     title: 'Judy Counter Stool - Painted',
//     dimention: ['0.51875', '0.5', '0.925'],
//     dimentionText: ['20.75"', '20"', '37"'],
//     uuid: '129',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 130,
//     product: Judy_dining_chair_natural,
//     title: 'Judy Dining Chair - Natural',
//     dimention: ['0.5625', '0.5675', '0.775'],
//     dimentionText: ['22.5"', '21.5"', '31"'],
//     uuid: '130',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       chairFrameFinish: 'Natural Maple',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 131,
//     product: Judy_dining_chair_painted,
//     title: 'Judy Dining Chair - Painted',
//     dimention: ['0.5625', '0.5375', '0.775'],
//     dimentionText: ['22.5"', '21.5"', '31"'],
//     uuid: '131',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 204,
//     product: Large_charlie_buffet,
//     title: 'Large Charlie Buffet',
//     dimention: ['1.45', '0.55', '0.9'],
//     dimentionText: ['58"', '22"', '36"'],
//     uuid: '204',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 205,
//     product: Large_margate_buffet,
//     title: 'Large Margate Buffet',
//     dimention: ['1.45', '0.55', '0.9'],
//     dimentionText: ['58"', '22"', '36"'],
//     uuid: '205',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 206,
//     product: Large_stowaway_shelf,
//     title: 'Large Stow-Away Shelf',
//     dimention: ['1.55', '0.35', '0.975'],
//     dimentionText: ['62"', '14"', '39"'],
//     uuid: '206',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 207,
//     product: Largest_stowaway_shelf,
//     title: 'Largest Stow-Away Shelf',
//     dimention: ['1.175', '0.35', '1.65'],
//     dimentionText: ['47"', '14"', '66"'],
//     uuid: '207',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 227,
//     product: Lattice_3drawer_dresser,
//     title: 'Lattice 3-Drawer Dresser',
//     dimention: ['0.95', '0.485', '0.95'],
//     dimentionText: ['38"', '19"', '38"'],
//     uuid: '227',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 223,
//     product: Lattice_bed,
//     title: 'Lattice Bed',
//     dimention: ['1.043', '2', '1.306'],
//     dimentionText: ['41.75"', '80"', '52.25"'],
//     uuid: '223',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 252,
//     product: Lattice_bed,
//     title: 'Lattice Bed',
//     dimention: ['1.443', '2', '1.306'],
//     dimentionText: ['57.75"', '80"', '52.25"'],
//     uuid: '223',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 253,
//     product: Lattice_bed,
//     title: 'Lattice Bed',
//     dimention: ['1.593', '2', '1.306'],
//     dimentionText: ['63.75"', '80"', '52.25"'],
//     uuid: '223',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 256,
//     product: Lattice_bed,
//     title: 'Lattice Bed',
//     dimention: ['2', '2', '1.306'],
//     dimentionText: ['79.75"', '80"', '52.25"'],
//     uuid: '223',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 224,
//     product: Lattice_day_bed,
//     title: 'Lattice Day Bed',
//     dimention: ['2.025', '1.068', '1.025'],
//     dimentionText: ['81"', '42.75"', '41"'],
//     uuid: '224',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 225,
//     product: Lattice_double_dresser,
//     title: 'Lattice Double Dresser',
//     dimention: ['1.65', '0.485', '0.95'],
//     dimentionText: ['66"', '19"', '38"'],
//     uuid: '225',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 226,
//     product: Lattice_tall_dresser_2over3,
//     title: 'Lattice Tall Dresser (2-Over-3)',
//     dimention: ['0.95', '0.485', '1.125'],
//     dimentionText: ['38"', '19"', '45"'],
//     uuid: '226',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 17,
//     product: Lilah_swivel_chair,
//     title: 'Lilah Swivel Chair',
//     dimention: ['0.775', '0.95', '0.95'],
//     dimentionText: ['31"', '38"', '38"'],
//     uuid: '17',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 65,
//     product: Lillian_bench,
//     title: 'Lillian Bench',
//     dimention: ['1.225', '0.525', '0.487'],
//     dimentionText: ['49"', '21"', '19.5"'],
//     uuid: '65',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       metalLegFinish: 'Slate Metal',
//     },
//   },
//   {
//     id: 171,
//     product: Little_cay_desk,
//     title: 'Little Cay Desk',
//     dimention: ['1.193', '0.6', '0.75'],
//     dimentionText: ['47.75"', '24"', '30"'],
//     uuid: '171',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 254,
//     product: Little_cay_desk,
//     title: 'Little Cay Desk',
//     dimention: ['1.193', '0.6', '0.75'],
//     dimentionText: ['47.75"', '24"', '30"'],
//     uuid: '171',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 178,
//     product: Lottie_dining_bench,
//     title: 'Lottie Dining Bench',
//     dimention: ['1.125', '0.45', '0.475'],
//     dimentionText: ['45"', '18"', '19"'],
//     uuid: '178',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 106,
//     product: Lottie_leaf_coffee_table,
//     title: 'Lottie Leaf Coffee Table',
//     dimention: ['1.3', '1.3', '0.475'],
//     dimentionText: ['52"', '52"', '19"'],
//     uuid: '106',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 107,
//     product: Lottie_leaf_console_table,
//     title: 'Lottie Leaf Console Table',
//     dimention: ['1.5', '0.425', '0.75'],
//     dimentionText: ['60"', '17"', '30"'],
//     uuid: '107',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 146,
//     product: Lottie_leaf_dining_table,
//     title: 'Lottie Leaf Dining Table',
//     dimention: ['1.9', '1.05', '0.75'],
//     dimentionText: ['76"', '42"', '30"'],
//     uuid: '146',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 193,
//     product: Lottie_leaf_stool,
//     title: 'Lottie Leaf Stool',
//     dimention: ['0.475', '0.425', '0.425'],
//     dimentionText: ['19"', '17"', '17"'],
//     uuid: '193',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 172,
//     product: Lottie_leaf_writing_desk,
//     title: 'Lottie Leaf Writing Desk',
//     dimention: ['1.625', '0.6', '0.75'],
//     dimentionText: ['65"', '24"', '30"'],
//     uuid: '172',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 194,
//     product: Lottie_side_table,
//     title: 'Lottie Side Table',
//     dimention: ['0.625', '0.5', '0.75'],
//     dimentionText: ['25"', '20"', '30"'],
//     uuid: '194',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 89,
//     product: Low_tide_day_bed,
//     title: 'Low Tide Day Bed',
//     dimention: ['2.025', '1.06875', '1.025'],
//     dimentionText: ['81"', '42.75"', '41"'],
//     uuid: '89',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 173,
//     product: Low_tide_desk,
//     title: 'Low Tide Desk',
//     dimention: ['1.375', '0.55', '0.775'],
//     dimentionText: ['55"', '22"', '31"'],
//     uuid: '173',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 108,
//     product: Low_tide_hall_table,
//     title: 'Low Tide Hall Table',
//     dimention: ['1.575', '0.35', '0.9'],
//     dimentionText: ['63"', '14"', '36"'],
//     uuid: '108',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 18,
//     product: Lucy_chair,
//     title: 'Lucy Chair',
//     dimention: ['0.875', '0.95', '1'],
//     dimentionText: ['35"', '38"', '40"'],
//     uuid: '18',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 257,
//     product: Lucy_chair,
//     title: 'Lucy Chair',
//     dimention: ['0.875', '0.95', '1'],
//     dimentionText: ['35"', '38"', '40"'],
//     uuid: '18',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 66,
//     product: Lucy_ottoman,
//     title: 'Lucy Ottoman',
//     dimention: ['0.675', '0.525', '0.437'],
//     dimentionText: ['27"', '21"', '17.5"'],
//     uuid: '66',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 90,
//     product: Mabel_bed,
//     title: 'Mabel Bed',
//     dimention: ['1.05', '2', '1.28'],
//     dimentionText: ['41.75"', '80"', '51.75"'],
//     uuid: '90',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 261,
//     product: Mabel_bed,
//     title: 'Mabel Bed',
//     dimention: ['1.44', '2', '1.344'],
//     dimentionText: ['57.75"', '80"', '53.75"'],
//     uuid: '90',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 262,
//     product: Mabel_bed,
//     title: 'Mabel Bed',
//     dimention: ['1.6', '2.125', '1.344'],
//     dimentionText: ['63.75"', '85"', '53.75"'],
//     uuid: '90',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 263,
//     product: Mabel_bed,
//     title: 'Mabel Bed',
//     dimention: ['1.99', '2.125', '1.344'],
//     dimentionText: ['79.75"', '86"', '53.75"'],
//     uuid: '90',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 179,
//     product: Margaret_bench,
//     title: 'Margaret Bench',
//     dimention: ['1.1', '0.5', '0.875'],
//     dimentionText: ['44"', '20"', '35"'],
//     uuid: '179',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 208,
//     product: Margate_bookshelf_with_doors,
//     title: 'Margate Bookshelf with Doors',
//     dimention: ['0.85', '0.375', '1.775'],
//     dimentionText: ['34"', '15"', '71"'],
//     uuid: '208',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 147,
//     product: Margate_dining_table,
//     title: 'Margate Dining Table',
//     dimention: ['1.5', '0.825', '0.75'],
//     dimentionText: ['60"', '33"', '30"'],
//     uuid: '147',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 281,
//     product: Margate_dining_table,
//     title: 'Margate Dining Table',
//     dimention: ['1.9', '0.9', '0.75'],
//     dimentionText: ['72"', '36"', '30"'],
//     uuid: '147',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 282,
//     product: Margate_dining_table,
//     title: 'Margate Dining Table',
//     dimention: ['2.1', '1', '0.75'],
//     dimentionText: ['84"', '40"', '30"'],
//     uuid: '147',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 148,
//     product: Margate_extension_dining_table,
//     title: 'Margate Extension Dining Table',
//     dimention: ['2.336', '1.1', '0.75'],
//     dimentionText: ['72" to 92"', '44"', '30"'],
//     uuid: '148',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 283,
//     product: Margate_extension_dining_table,
//     title: 'Margate Extension Dining Table',
//     dimention: ['2.8', '1.1', '0.75'],
//     dimentionText: ['72" to 112"', '44"', '30"'],
//     uuid: '148',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 209,
//     product: Margate_media_console,
//     title: 'Margate Media Console',
//     dimention: ['1.194', '0.475', '1'],
//     dimentionText: ['47.75"', '19"', '40"'],
//     uuid: '209',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 19,
//     product: Margot_chair,
//     title: 'Margot Chair',
//     dimention: ['0.9', '0.9', '0.825'],
//     dimentionText: ['36"', '36"', '33"'],
//     uuid: '19',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       turnedLegFinish: 'Nordic',
//     },
//   },
//   {
//     id: 20,
//     product: Max_chair,
//     title: 'Max Chair',
//     dimention: ['0.775', '0.8625', '0.9625'],
//     dimentionText: ['31"', '34.5"', '38.5"'],
//     uuid: '20',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 210,
//     product: Medium_stowaway_shelf,
//     title: 'Medium Stow-Away Shelf',
//     dimention: ['1.175', '0.35', '0.975'],
//     dimentionText: ['47"', '14"', '39"'],
//     uuid: '210',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 91,
//     product: Meriweather_bed,
//     title: 'Meriweather Bed',
//     dimention: ['1.05', '2', '1.3'],
//     dimentionText: ['42"', '80"', '53"'],
//     uuid: '91',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 264,
//     product: Meriweather_bed,
//     title: 'Meriweather Bed',
//     dimention: ['1.44', '2', '1.344'],
//     dimentionText: ['57.75"', '80"', '53"'],
//     uuid: '91',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 265,
//     product: Meriweather_bed,
//     title: 'Meriweather Bed',
//     dimention: ['1.6', '2.125', '1.344'],
//     dimentionText: ['63.75"', '85"', '53"'],
//     uuid: '91',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 266,
//     product: Meriweather_bed,
//     title: 'Meriweather Bed',
//     dimention: ['1.99', '2.125', '1.344'],
//     dimentionText: ['79.75"', '86"', '53"'],
//     uuid: '91',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 67,
//     product: Mia_bench,
//     title: 'Mia Bench',
//     dimention: ['1.175', '0.737', '0.462'],
//     dimentionText: ['47"', '29.5"', '18.5"'],
//     uuid: '67',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       turnedLegFinish: 'Nordic',
//     },
//   },
//   {
//     id: 68,
//     product: Milly_storage_ottoman,
//     title: 'Milly Storage Ottoman',
//     dimention: ['0.975', '0.65', '0.425'],
//     dimentionText: ['39"', '26"', '17"'],
//     uuid: '68',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 21,
//     product: Milly_twin_sleeper_chair,
//     title: 'Milly Twin Sleeper Chair',
//     dimention: ['1.1375', '0.9', '0.85'],
//     dimentionText: ['45.5"', '36"', '34"'],
//     uuid: '21',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 132,
//     product: Minnie_counter_stool,
//     title: 'Minnie Counter Stool',
//     dimention: ['0.45', '0.375', '0.775'],
//     dimentionText: ['18"', '15"', '31"'],
//     uuid: '132',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 180,
//     product: Molly_bench,
//     title: 'Molly Bench',
//     dimention: ['0.8', '0.425', '0.475'],
//     dimentionText: ['32"', '17"', '19"'],
//     uuid: '180',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 50,
//     product: Monty_sofa,
//     title: 'Monty Sofa',
//     dimention: ['2.1', '0.925', '0.875'],
//     dimentionText: ['84"', '37"', '35"'],
//     uuid: '50',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 69,
//     product: Morgan_ottoman,
//     title: 'Morgan Ottoman',
//     dimention: ['1.175', '1.175', '0.462'],
//     dimentionText: ['47"', '47"', '18.5"'],
//     uuid: '69',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       turnedLegFinish: 'Nordic',
//     },
//   },
//   {
//     id: 195,
//     product: Nellie_2drawer_bedside_table,
//     title: 'Nellie 2-Drawer Bedside Table',
//     dimention: ['0.55', '0.5', '0.7'],
//     dimentionText: ['22"', '20"', '28"'],
//     uuid: '195',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 165,
//     product: Nellie_2over2dresser,
//     title: 'Nellie 2-Over-2-Dresser',
//     dimention: ['1', '0.5', '0.9'],
//     dimentionText: ['40"', '20"', '36"'],
//     uuid: '165',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 166,
//     product: Nellie_3drawer_dresser,
//     title: 'Nellie 3-Drawer Dresser',
//     dimention: ['1', '0.5', '0.9'],
//     dimentionText: ['40"', '20"', '36"'],
//     uuid: '166',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 167,
//     product: Nellie_double_dresser,
//     title: 'Nellie Double Dresser',
//     dimention: ['1.6', '0.5', '0.9'],
//     dimentionText: ['64"', '20"', '36"'],
//     uuid: '167',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 196,
//     product: Nellie_end_table,
//     title: 'Nellie End Table',
//     dimention: ['0.55', '0.5', '0.75'],
//     dimentionText: ['22"', '20"', '30"'],
//     uuid: '196',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 22,
//     product: Nina_chair,
//     title: 'Nina Chair',
//     dimention: ['0.775', '0.825', '0.775'],
//     dimentionText: ['31"', '33"', '31"'],
//     uuid: '22',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 248,
//     product: Nina_chair,
//     title: 'Nina Chair',
//     dimention: ['0.775', '0.825', '0.775'],
//     dimentionText: ['31"', '33"', '31"'],
//     uuid: '22',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 23,
//     product: Olivia_chair,
//     title: 'Olivia Chair',
//     dimention: ['0.65', '0.775', '1.15'],
//     dimentionText: ['26"', '31"', '46"'],
//     uuid: '23',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 24,
//     product: Oscar_chair,
//     title: 'Oscar Chair',
//     dimention: ['0.725', '0.9125', '0.85'],
//     dimentionText: ['29"', '36.5"', '34"'],
//     uuid: '24',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 71,
//     product: Paige_bench,
//     title: 'Paige Bench',
//     dimention: ['0.913', '0.525', '0.6'],
//     dimentionText: ['36.5"', '21"', '24"'],
//     uuid: '71',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 25,
//     product: Piper_chair,
//     title: 'Piper Chair',
//     dimention: ['0.7625', '0.75', '1'],
//     dimentionText: ['30.5"', '30"', '40"'],
//     uuid: '25',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 26,
//     product: Quinn_chair,
//     title: 'Quinn Chair',
//     dimention: ['0.725', '0.825', '0.862'],
//     dimentionText: ['29"', '33"', '34.5"'],
//     uuid: '26',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 247,
//     product: Quinn_chair,
//     title: 'Quinn Chair',
//     dimention: ['0.725', '0.825', '0.862'],
//     dimentionText: ['29"', '33"', '34.5"'],
//     uuid: '26',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 34,
//     product: Retreat_monterey_barrel_back_swivel_chair,
//     title: 'RETREAT - Monterey Barrel Back Swivel Chair',
//     dimention: ['0.887', '1.05', '0.937'],
//     dimentionText: ['35.5"', '42"', '37.5"'],
//     uuid: '34',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       retreatFabricFinish: 'Freckles : Skyline',
//     },
//   },
//   {
//     id: 33,
//     product: Retreat_monterey_chair,
//     title: 'RETREAT - Monterey Chair',
//     dimention: ['0.937', '1.037', '0.937'],
//     dimentionText: ['37.5"', '41.5"', '37.5"'],
//     uuid: '33',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       retreatFabricFinish: 'Freckles : Skyline',
//       retreatLegFinish: 'Sea Salt',
//     },
//   },
//   {
//     id: 38,
//     product: Retreat_monterey_sofa,
//     title: 'RETREAT - Monterey Sofa',
//     dimention: ['2.225', '1.037', '0.937'],
//     dimentionText: ['89"', '41.5"', '37.5"'],
//     uuid: '38',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       retreatFabricFinish: 'Freckles : Skyline',
//       retreatLegFinish: 'Sea Salt',
//     },
//   },
//   {
//     id: 35,
//     product: Retreat_nantucket_chair,
//     title: 'RETREAT - Nantucket Chair',
//     dimention: ['0.912', '0.812', '0.912'],
//     dimentionText: ['36.5"', '34.5"', '36.5"'],
//     uuid: '35',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       retreatFabricFinish: 'Freckles : Skyline',
//     },
//   },
//   {
//     id: 36,
//     product: Retreat_nantucket_chair_and_a_half_sleeper,
//     title: 'RETREAT - Nantucket Chair and A Half Sleeper',
//     dimention: ['1.275', '0.925', '0.912'],
//     dimentionText: ['51"', '37"', '36.5"'],
//     uuid: '36',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       retreatFabricFinish: 'Freckles : Skyline',
//     },
//   },
//   {
//     id: 39,
//     product: Retreat_nantucket_sofa,
//     title: 'RETREAT - Nantucket Sofa',
//     dimention: ['2.063', '0.812', '0.912'],
//     dimentionText: ['82.5"', '34.5"', '36.5"'],
//     uuid: '39',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       retreatFabricFinish: 'Freckles : Skyline',
//     },
//   },
//   {
//     id: 37,
//     product: Retreat_palm_beach_chair,
//     title: 'RETREAT - Palm Beach Chair',
//     dimention: ['0.837', '0.95', '0.837'],
//     dimentionText: ['33.5"', '38"', '33.5"'],
//     uuid: '37',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       retreatFabricFinish: 'Freckles : Skyline',
//     },
//   },
//   {
//     id: 70,
//     product: Ruben_hassock,
//     title: 'Ruben Hassock',
//     dimention: ['0.55', '0.55', '0.375'],
//     dimentionText: ['22"', '22"', '15"'],
//     uuid: '70',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 211,
//     product: Ruby_sound_cabinet,
//     title: 'Ruby Sound Cabinet',
//     dimention: ['1.175', '0.525', '0.65'],
//     dimentionText: ['47"', '21"', '26"'],
//     uuid: '211',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 133,
//     product: Sanibel_counter_stool_natural,
//     title: 'Sanibel Counter Stool - Natural',
//     dimention: ['0.3875', '0.3875', '0.6'],
//     dimentionText: ['15.5"', '15.5"', '24"'],
//     uuid: '133',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       chairFrameFinish: 'Natural Maple',
//     },
//   },
//   {
//     id: 134,
//     product: Sanibel_counter_stool_painted,
//     title: 'Sanibel Counter Stool - Painted',
//     dimention: ['0.3875', '0.3875', '0.6'],
//     dimentionText: ['15.5"', '15.5"', '24"'],
//     uuid: '134',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 72,
//     product: Shelby_bench,
//     title: 'Shelby Bench',
//     dimention: ['1.3', '0.8', '0.5'],
//     dimentionText: ['52"', '32"', '20"'],
//     uuid: '72',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 27,
//     product: Shelby_chair,
//     title: 'Shelby Chair',
//     dimention: ['0.775', '0.9', '0.825'],
//     dimentionText: ['31"', '36"', '33"'],
//     uuid: '27',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 73,
//     product: Shelby_ottoman,
//     title: 'Shelby Ottoman',
//     dimention: ['0.625', '0.5', '0.45'],
//     dimentionText: ['25"', '20"', '18"'],
//     uuid: '73',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 51,
//     product: Shelby_sofa,
//     title: 'Shelby Sofa',
//     dimention: ['2.175', '0.95', '0.825'],
//     dimentionText: ['87"', '38"', '33"'],
//     uuid: '51',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 93,
//     product: Shutter_bed,
//     title: 'Shutter Bed',
//     dimention: ['1.05', '2', '1.3'],
//     dimentionText: ['42"', '80"', '53"'],
//     uuid: '93',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 267,
//     product: Shutter_bed,
//     title: 'Shutter Bed',
//     dimention: ['1.44', '2', '1.344'],
//     dimentionText: ['57.75"', '80"', '53"'],
//     uuid: '93',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 268,
//     product: Shutter_bed,
//     title: 'Shutter Bed',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 269,
//     product: Shutter_bed,
//     title: 'Shutter Bed',
//     dimention: ['1.99', '2.125', '1.344'],
//     dimentionText: ['79.75"', '86"', '53"'],
//     uuid: '93',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 94,
//     product: Shutter_bunk_bed,
//     title: 'Shutter Bunk Bed',
//     dimention: ['1.05', '2', '1.825'],
//     dimentionText: ['42"', '80"', '73"'],
//     uuid: '94',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 1,
//     product: Signature_cord_welt_pillow,
//     title: 'Signature Cord Welt Pillow',
//     dimention: ['0.459', '0.214', '0.455'],
//     dimentionText: ['18"', '8.5"', '18"'],
//     uuid: '1',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 2,
//     product: Signature_kidney_pillow,
//     title: 'Signature Kidney Pillow',
//     dimention: ['0.485', '0.1475', '0.26'],
//     dimentionText: ['19"', '6"', '10"'],
//     uuid: '2',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 212,
//     product: Skinniest_island_bookshelf,
//     title: 'Skinniest Island Bookshelf',
//     dimention: ['0.725', '0.375', '1.675'],
//     dimentionText: ['23"', '15"', '67"'],
//     uuid: '212',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 213,
//     product: Small_island_bookshelf,
//     title: 'Small Island Bookshelf',
//     dimention: ['1.075', '0.375', '0.975'],
//     dimentionText: ['43"', '15"', '39"'],
//     uuid: '213',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 214,
//     product: Small_margate_buffet,
//     title: 'Small Margate Buffet',
//     dimention: ['1', '0.55', '0.9'],
//     dimentionText: ['40"', '22"', '36"'],
//     uuid: '214',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 215,
//     product: Small_stowaway_shelf,
//     title: 'Small Stow-Away Shelf',
//     dimention: ['0.8', '0.35', '0.975'],
//     dimentionText: ['32"', '14"', '39"'],
//     uuid: '215',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 216,
//     product: Smallest_island_bookshelf,
//     title: 'Smallest Island Bookshelf',
//     dimention: ['0.575', '0.375', '0.975'],
//     dimentionText: ['23"', '15"', '39"'],
//     uuid: '216',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 28,
//     product: Stevie_chair,
//     title: 'Stevie Chair',
//     dimention: ['0.875', '0.9', '0.9'],
//     dimentionText: ['35"', '36"', '36"'],
//     uuid: '28',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 74,
//     product: Stevie_ottoman,
//     title: 'Stevie Ottoman',
//     dimention: ['0.75', '0.55', '0.462'],
//     dimentionText: ['30"', '22"', '18.5"'],
//     uuid: '74',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 52,
//     product: Stevie_sofa_x,
//     title: 'Stevie Sofa - X',
//     dimention: ['2.175', '0.9', '0.9'],
//     dimentionText: ['87"', '36"', '36"'],
//     uuid: '52',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 75,
//     product: Suri_ottoman,
//     title: 'Suri Ottoman',
//     dimention: ['0.675', '0.675', '0.475'],
//     dimentionText: ['27"', '27"', '19"'],
//     uuid: '75',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 217,
//     product: Tall_stowaway_shelf,
//     title: 'Tall Stow-Away Shelf',
//     dimention: ['0.8', '0.35', '1.65'],
//     dimentionText: ['32"', '14"', '66"'],
//     uuid: '217',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 109,
//     product: Tide_pool_hall_table,
//     title: 'Tide Pool Hall Table',
//     dimention: ['1.0625', '0.4', '0.8125'],
//     dimentionText: ['42.5"', '16"', '32.5"'],
//     uuid: '109',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 197,
//     product: Tide_pool_side_table,
//     title: 'Tide Pool Side Table',
//     dimention: ['0.425', '0.75', '0.5'],
//     dimentionText: ['17"', '30"', '20"'],
//     uuid: '197',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 29,
//     product: Tilly_chair,
//     title: 'Tilly Chair',
//     dimention: ['0.725', '0.625', '0.95'],
//     dimentionText: ['29"', '25"', '38"'],
//     uuid: '29',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legPaintColorFinish: 'Nordic',
//     },
//   },
//   {
//     id: 76,
//     product: Tilly_ottoman,
//     title: 'Tilly Ottoman',
//     dimention: ['0.6', '0.5', '0.5'],
//     dimentionText: ['24"', '20"', '20"'],
//     uuid: '76',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legPaintColorFinish: 'Nordic',
//     },
//   },
//   {
//     id: 110,
//     product: Topper_coffee_table,
//     title: 'Topper Coffee Table',
//     dimention: ['1.15', '1.15', '0.475'],
//     dimentionText: ['46"', '46"', '19"'],
//     uuid: '110',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       woodTopFinish: 'Painted',
//     },
//   },
//   {
//     id: 218,
//     product: Trundle_bed,
//     title: 'Trundle Bed',
//     dimention: ['0.962', '1.775', '0.237'],
//     dimentionText: ['38.5"', '71"', '9.5"'],
//     uuid: '218',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   {
//     id: 77,
//     product: Tulla_tuffet_ottoman,
//     title: 'Tulla Tuffet Ottoman',
//     dimention: ['0.425', '0.425', '0.425'],
//     dimentionText: ['17"', '17"', '17"'],
//     uuid: '77',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 198,
//     product: Wendy_side_table,
//     title: 'Wendy Side Table',
//     dimention: ['0.5', '0.5', '0.65'],
//     dimentionText: ['20"', '20"', '26"'],
//     uuid: '198',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//     },
//   },
//   // {
//   //   id: 30,
//   //   product: Wilton_chair,
//   //   title: "Wilton Chair",
//   //  dimention: ["0.85",
//   //  modelDepth: "0.85",
//   //  modelHeight: "0.875",
//   //  textWidth: '34"',
//   //  textDepth: '34"',
//   //  textHeight: '35"',
//   //  uuid: "30",
//   // },
//   // {
//   //   id: 245,
//   //   product: Wilton_chair,
//   //   title: "Wilton Chair",
//   //  dimention: ["0.85",
//   //  modelDepth: "0.85",
//   //  modelHeight: "0.875",
//   //  textWidth: '34"',
//   //  textDepth: '34"',
//   //  textHeight: '35"',
//   //  uuid: "30",
//   // },
//   // {
//   //   id: 246,
//   //   product: Wilton_chair,
//   //   title: "Wilton Chair",
//   //  dimention: ["0.85",
//   //  modelDepth: "0.85",
//   //  modelHeight: "0.875",
//   //  textWidth: '34"',
//   //  textDepth: '34"',
//   //  textHeight: '35"',
//   //  uuid: "30",
//   // },
//   {
//     id: 78,
//     product: Wilton_skirted_ottoman,
//     title: 'Wilton Skirted Ottoman',
//     dimention: ['0.65', '0.4', '0.475'],
//     dimentionText: ['26"', '16"', '19"'],
//     uuid: '78',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 53,
//     product: Wilton_skirted_sofa,
//     title: 'Wilton Skirted Sofa',
//     dimention: ['2.1', '0.875', '0.925'],
//     dimentionText: ['84"', '35"', '37"'],
//     uuid: '53',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 54,
//     product: Wilton_skirtless_sofa,
//     title: 'Wilton Skirtless Sofa',
//     dimention: ['2.1', '0.875', '0.925'],
//     dimentionText: ['84"', '35"', '37"'],
//     uuid: '54',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
//   {
//     id: 136,
//     product: Windsor_arm_chair_painted,
//     title: 'Windsor Arm Chair',
//     dimention: ['0.5875', '0.5875', '0.99375'],
//     dimentionText: ['23.5"', '23.5"', '39.75"'],
//     uuid: '136',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 135,
//     product: Windsor_Arm_Chair_Natural,
//     title: 'Windsor Arm Chair - Natural',
//     dimention: ['0.5875', '0.5875', '0.99375'],
//     dimentionText: ['23.5"', '23.5"', '39.75"'],
//     uuid: '135',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       chairFrameFinish: 'Natural Maple',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 137,
//     product: Windsor_dining_chair_natural,
//     title: 'Windsor Dining Chair - Natural',
//     dimention: ['0.525', '0.56875', '0.99375'],
//     dimentionText: ['21"', '22.75"', '39.75"'],
//     uuid: '137',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       chairFrameFinish: 'Natural Maple',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 138,
//     product: Windsor_dining_chair_painted,
//     title: 'Windsor Dining Chair - Painted',
//     dimention: ['0.525', '0.56875', '0.99375'],
//     dimentionText: ['21"', '22.75"', '39.75"'],
//     uuid: '138',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       paintColorFinish: 'Bluebell',
//       cushionFinish: 'No Cushion',
//     },
//   },
//   {
//     id: 31,
//     product: Winnie_chair,
//     title: 'Winnie Chair',
//     dimention: ['0.75', '0.95', '0.9'],
//     dimentionText: ['30"', '38"', '36"'],
//     uuid: '31',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//     },
//   },
//   {
//     id: 32,
//     product: Winnie_chaise,
//     title: 'Winnie Chaise',
//     dimention: ['0.75', '1.6', '0.9'],
//     dimentionText: ['30"', '64"', '36"'],
//     uuid: '32',
//     repeatFactor: [1, 1],
//     offsetFactor: [0, 0],
//     cameraMinMaxZoomDistance: [0, 5],
//     cameraInitPos: [-5, 1, 25, 10],
//     cameraTarget: [0, 0.4, 0],
//     default: {
//       upholsteryFinish: 'Thatch : Bluebell',
//       legFinish: 'Nordic',
//     },
//   },
// ];
